import React from "react";

import {
  CheckOutlined,
  CloseOutlined,
  DownOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
  PlayCircleOutlined,
  ReloadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button, Dropdown, Input, Tooltip,
} from "antd";
import Modal from "antd/es/modal/Modal";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import { sortBy } from "lodash";
import moment from "moment";
import { Carousel } from "react-responsive-carousel";
import { toast } from "react-toastify";

import { AppContext } from "../../../../../AppContext";
import { SPEC_FLAGS_MAP } from "../../../../Common/constants/SpecFlagConstants";
import NoResults from "../../../../Common/NoResults";
import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import StyledTooltip from "../../../../Common/UIComponents/StyledTooltip";
import LockedValue from "../../../../grace-period/components/LockedValue";
import { CHAR_LIMITS } from "../../../../SampleSubmission/SubmissionForm/Constant";
import { formatSpecAlertLabel } from "../../ReportsTable/alertRemainingUtils";
import ReportPreviewModal from "../Preview/ReportPreviewModal";
import ContactCsmModal from "./ContactCsmModal";
import ContactCsmSuccessModal from "./ContactCsmSuccessModal";
import ConvertUnitModal from "./ConvertUnitModal";
import DatePicker from "./DatePicker";
import EditSampleIdModal from "./EditSampleIdModal";
import {
  MAX_RETESTS_ALLOWED, VALID_SPECS_SET, hasSentFinalResults, flattenCoaFilePaths, getColorForTestResult,
  formatPendingRetestBannerDate, getPreferredEditedSampleId, getPreferredEditedSampleType, getTotalSampleSize,
  hasSampleIdEditHistory, hasSampleTypeEditHistory, hasUnitConversionHistory,
  isUnitConversionUnavailableForMissingSpecUnit, resolveDisplaySampleId, resolveDisplaySampleType,
  resolveModalCoaFilePaths,
} from "./helper";
import NewSampleDatePickerModal from "./NewSampleDatePickerModal";
import NewSampleRetestConfirmationModal from "./NewSampleRetestConfirmationModal";
import NewSampleRetestReceiptModal from "./NewSampleRetestReceiptModal";
import NewSampleRetestSuccessModal from "./NewSampleRetestSuccessModal";
import {
  hideUpdateSpecsPromptPermanently,
  partitionTestsForOosRelease,
  sampleHasResultsReviewTabs,
  shouldOfferUpdateSpecsPrompt,
  getSuggestedSpecTest,
  isOosReviewSelectable,
  RELEASE_RESULT_STATUS,
} from "./oosReview";
import ReleaseTestResultsModal from "./ReleaseTestResultsModal";
import ReleaseTestSuccessModal from "./ReleaseTestSuccessModal";
import RetestMethodModal from "./RetestMethodModal";
import SampleIdActionsMenu from "./SampleIdActionsMenu";
import SampleIdChangeHistoryModal, { SAMPLE_TYPE_HISTORY_COLUMNS } from "./SampleIdChangeHistoryModal";
import SampleTestResultTable from "./SampleTestResultTable";
import SendNewSampleWizardModal from "./SendNewSampleWizardModal";

import { getUserCredentials } from "../../../../../utils/common";
import { downloadFileFromS3WithPresigned } from "../../../../../utils/helpers";
import {
  hasPermission,
  permissions,
  canRequestProductRetest,
  canEditSampleId,
  canEditSampleType,
} from "../../../../../utils/Permissions";

import { getEnvSpec } from "../../../../../actions/envAnalytics";
import {
  getSpec, requestRetest, generatePartialReport, getSampleIdEditHistory, getSampleTypeEditHistory, saveSampleTypeEditHistory,
  saveUnitConversionResult, setUnitsToDefault,
  requestRetestNewSample, releaseTestResults, contactCsm, notifyDontUpdateSpecs,
} from "../../../../../actions/reports";

import { ReactComponent as LoadingDots } from "../../../../../assets/images/common/LoadingDots.svg";
import emptyStateIcon from "../../../../../assets/images/EmptyState_V2.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../../Product.css";
import "../SpecManager/SpecManagerModal.css";
import "./SampleResultsModal.css";
import "./SampleTestResultTable.css";

class SampleResultsModal extends React.Component {
  testResultTableRefs = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      sampleResultsData: null,
      showRetestModal: false,
      keyOfTestResultTable: true, // this key is used to trigger a re-render of SampleTestResultTable component
      currentSlide: 0,
      totalSlides: 0,
      awaitingRetestRequest: false,
      isPickingRetests: false,
      testToRetest: [],
      isPickingPartialGenerate: false,
      testsForPartialGenerate: [],
      activeDate: "",
      isInProcess: false,
      disabledTests: new Map(), // Map of "date|test" -> true
      disabledTestsForPartialGenerate: new Map(), // Map of "date|test" -> true
      loadingUpdatedData: false,
      loadingPartialGenerate: false,
      loadingData: true,
      showDetailedPesticideReport: false,
      pesticideDetailTest: null,
      reportPath: {},
      showEditSampleIdModal: false,
      showSampleIdChangeHistoryModal: false,
      displaySampleIdOverride: null,
      hasSampleIdEditHistoryOverride: false,
      hasUnitConversionHistoryOverride: false,
      sampleIdEditHistoryForEdit: [],
      showSampleTypeChangeHistoryModal: false,
      displaySampleTypeOverride: null,
      hasSampleTypeEditHistoryOverride: false,
      isEditingSampleType: false,
      sampleTypeDraft: "",
      savingSampleType: false,
      showCoaPreview: false,
      loadingRegenerateCoa: false,
      loadingCoaDownload: false,
      showConvertUnitModal: false,
      convertUnitRow: null,
      isSavingUnitConversion: false,
      isResettingUnitsToDefault: false,
      showRetestMethodModal: false,
      showNewSampleDatePicker: false,
      showNewSampleConfirmation: false,
      newSampleDate: null,
      awaitingNewSampleRequest: false,
      showNewSampleRetestSuccess: false,
      newSampleRetestSuccessDate: null,
      showNewSampleRetestReceipt: false,
      newSampleRetestReceiptSubmission: null,
      showSendNewSampleWizard: false,
      reviewSendNewSampleLoading: false,
      reviewNewSampleSuccessHeading: "Retest Request created for",
      resultsReviewTab: "results",
      showReleaseConfirm: false,
      testToRelease: null,
      testToReleaseDate: "",
      releasingTest: false,
      showReleaseSuccess: false,
      pendingRelease: null,
      tabCountBurst: null,
      holdResultsReviewTabs: false,
      reviewSelectedTests: [],
      showContactCsmModal: false,
      showContactCsmSuccess: false,
      submittingContactCsm: false,
      showUpdateSpecsPrompt: false,
      releasedTestItem: null,
      releasedTestDate: "",
      // pesticideCommodity: "", //NOTE: value not being shown in current cycle
      // isRetest: false,
      // isOutOfSpec: false,
    };
  }

  componentDidMount() {
    const { sampleCategory } = this.props;
    this.setState({ loadingData: true });
    if (sampleCategory === "environment") {
      this.envGetSampleResults().then((result) => {
        if (result) {
          const { sampleResultsData, isInProcess, totalSlides } = result;
          this.setState({
            sampleResultsData,
            isInProcess,
            totalSlides,
            activeDate: sampleResultsData.data[0][0],
            reportPath: sampleResultsData?.report_path,
            resultsReviewTab: this.getDefaultResultsReviewTab(sampleResultsData),
          });
        }
        this.setState({ loadingData: false });
      });
    } else {
      this.getSampleResults().then((result) => {
        if (result) {
          const { sampleResultsData, isInProcess, totalSlides } = result;
          // const hasPesticideTestByDate = this.f(); //NOTE: Used for Sample Type. Kept for future use

          this.setState({
            sampleResultsData,
            isInProcess,
            totalSlides,
            activeDate: sampleResultsData.data[0][0],
            reportPath: sampleResultsData?.report_path,
            resultsReviewTab: this.getDefaultResultsReviewTab(sampleResultsData),
          });
        }
        this.setState({ loadingData: false });
      });
    }
  }

  componentWillUnmount() {
    if (this.tabCountBurstTimer) {
      window.clearTimeout(this.tabCountBurstTimer);
    }
    if (this.updateSpecsPromptTimer) {
      window.clearTimeout(this.updateSpecsPromptTimer);
    }
  }

  /**
   * Refresh report data by calling getSampleResutls
   */
  reportDataRefresh = () => {
    this.setState({ loadingData: true });
    const { sampleCategory } = this.props;
    if (sampleCategory === "environment") {
      this.envGetSampleResults().then((result) => {
        if (result) {
          const { sampleResultsData, isInProcess, totalSlides } = result;
          this.setState((state) => ({
            sampleResultsData,
            isInProcess,
            totalSlides,
            activeDate: state.activeDate,
            reportPath: sampleResultsData?.report_path,
            hasUnitConversionHistoryOverride: hasUnitConversionHistory(sampleResultsData)
              ? state.hasUnitConversionHistoryOverride
              : false,
          }));
        }
        this.setState({ loadingData: false });
      });
    } else {
      this.getSampleResults().then((result) => {
        if (result) {
          const { sampleResultsData, isInProcess, totalSlides } = result;
          // const hasPesticideTestByDate = this.checkPesticideTestByDate(); //NOTE: Used for Sample Type. Kept for future use

          this.setState((state) => ({
            sampleResultsData,
            isInProcess,
            totalSlides,
            activeDate: state.activeDate,
            reportPath: sampleResultsData?.report_path,
            hasUnitConversionHistoryOverride: hasUnitConversionHistory(sampleResultsData)
              ? state.hasUnitConversionHistoryOverride
              : false,
          }));
        }
        this.setState({ loadingData: false });
      });
    }
  }

  /**
  * Fetch sample data (spec flag, link report field values, test results)
  */
  getSampleResults = async () => {
    const { reportData } = this.props;
    if (reportData) {
      const {
        index_id, index, report_id, sample_id, sample_type, product_type, received_date,
      } = reportData;
      const params = {
        type: "Report",
        index,
        index_id,
        report_id,
        sample_id,
        product_type,
        received_date: received_date ? moment(new Date(received_date)).format("YYYY/MM/DD") : "",
        sample_type,
      };
      if (params.index === null || params.index === undefined) {
        params.index = "Product";
      }

      const response = await getSpec(params);
      if (response && response.success) {
        const result = response.spec;
        if (Object.values(result).length === 0) {
          toast.error(
            "Oops, something went wrong. Please try again later.",
          );
          return null;
        }
        const isInProcess = Object.values(result.report_result)
          .flat()
          .every((item) => item.test_spec_flag.toString() === "0");
        // const isRetest = specs_flag && specs_flag.includes("Retest");
        // const isInProcess = specs_flag && specs_flag.includes("In Process");
        // const isOutOfSpec = specs_flag && specs_flag.includes("Out of Spec");

        const dataObj = Object.entries(result.report_result);
        dataObj.forEach((data) => {
          const coloredData = getColorForTestResult(data[1]);
          data[1] = coloredData;
        });

        const sampleResultsData = {
          ...result,
          data: dataObj,
          pending_retest_submission_data: response.pending_retest_submission_data || null,
        };
        sampleResultsData.data.sort((a, b) => Date.parse(b[0]) - Date.parse(a[0])); // sorts in place
        this.setTestsToDisable(sampleResultsData);
        this.setTestsToDisableForPartialGenerate(sampleResultsData);
        return { sampleResultsData, isInProcess, totalSlides: Object.keys(sampleResultsData.data).length };
      }
      toast.error("Failed to load report specs");
      return null;
    }
    return null;
  };

  /**
  * Fetch sample data (spec flag, link report field values, test results)
  */
  envGetSampleResults = async () => {
    const { reportData, specMethodReference } = this.props;
    if (reportData) {
      const {
        sample_id, location_id, sample_type, received_date,
      } = reportData;
      const params = {
        sample_id,
        location_id,
        received_date: received_date ? moment(new Date(received_date)).format("YYYY/MM/DD") : "",
        sample_type,
      };

      const response = await getEnvSpec(params, specMethodReference);
      if (response && response.success) {
        const result = response.spec;
        if (Object.values(result).length === 0) {
          toast.error(
            "Oops, something went wrong. Please try again later.",
          );
          return null;
        }
        const isInProcess = Object.values(result.report_result)
          .flat()
          .every((item) => item.test_spec_flag.toString() === "0");

        const dataObj = Object.entries(result.report_result);
        dataObj.forEach((data) => {
          const coloredData = getColorForTestResult(data[1]);
          data[1] = coloredData;
        });

        const sampleResultsData = { ...result, data: dataObj };
        sampleResultsData.data.sort((a, b) => Date.parse(b[0]) - Date.parse(a[0])); // sorts in place

        this.setTestsToDisable(sampleResultsData);
        return { sampleResultsData, isInProcess, totalSlides: Object.keys(sampleResultsData.data).length };
      }
      toast.error("Failed to load report specs");
      return null;
    }
    return null;
  };

  /**
   * Disable tests that are not eligible for Request Retest for specific dates.
   * Selectable only when: has result, Out of Spec (2/6), not Due By, empty message.
   * Tests are disabled per date, not globally.
   * @param {Object} results results.data = [[date, testResults], [date, testResults], ...]
   */
  setTestsToDisable = (results) => {
    const disabledTests = new Map();
    results.data.forEach(([date, testResults]) => { // eslint-disable-line
      testResults.forEach(({
        test, test_spec_flag, result, message,
      }) => {
        // Disable if:
        // - no result (empty or "-")
        // - not Out of Spec / Out of Spec (Retest) (test_spec_flag !== "2" and !== "6")
        // - test has "due" status (test_spec_flag === "0" or result starts with "Due By")
        // - has preliminary results (non-empty message)
        const specFlag = test_spec_flag != null ? test_spec_flag.toString() : "";
        const resultText = result ?? "";
        const isOutOfSpec = specFlag === "2" || specFlag === "6";
        const isDue = specFlag === "0" || resultText.startsWith("Due By");
        const hasNoResult = !resultText || resultText === "-" || resultText.trim() === "";
        if (hasNoResult || !isOutOfSpec || isDue || (message ?? "").trim() !== "") {
          // Use "date|test" as key to make it date-specific
          disabledTests.set(`${date}|${test}`, true);
        }
      });
    });
    this.setState({ disabledTests });
  };

  /**
   * Set tests to disable for partial generate - exclude tests with "due" status or preliminary results
   * Tests are disabled per date, not globally.
   * @param {Object} results results.data = [[date, testResults], [date, testResults], ...]
   */
  setTestsToDisableForPartialGenerate = (results) => {
    const disabledTestsForPartialGenerate = new Map();
    results.data.forEach(([date, testResults]) => { // eslint-disable-line
      testResults.forEach(({
        test, test_spec_flag, message, test_category,
      }) => {
        // Disable if:
        // - test has "due" status (test_spec_flag === "0")
        // - has preliminary results
        // - test_category is MRL (pesticide tests not allowed for partial reports)
        // - test_result is empty/missing (no result available)
        if (test_spec_flag === "0" || message?.trim() !== "" || test_category === "MRL") {
          // Use "date|test" as key to make it date-specific
          disabledTestsForPartialGenerate.set(`${date}|${test}`, true);
        }
      });
    });
    this.setState({ disabledTestsForPartialGenerate });
  };

  handleRetestRequest = async () => {
    const { testToRetest } = this.state;
    const { reportData } = this.props;

    this.setState({ awaitingRetestRequest: true });

    const date = moment(new Date(reportData.received_date)).format("YYYY-MM-DD");
    const payload = {
      sample_id: reportData.sample_id,
      received_at: date,
      tests: Array.from(new Set(testToRetest)),
      sample_type: reportData.sample_type,
    };

    const response = await requestRetest(payload);
    if (response && response.success) {
      if (this.testResultTableRefs.current) {
        this.testResultTableRefs.current.forEach((table) => table?.clearCheckboxes());
      }
      this.setState({
        showRetestModal: false,
        awaitingRetestRequest: false,
        isPickingRetests: false,
        showNewSampleRetestSuccess: true,
        newSampleRetestSuccessDate: moment(),
        newSampleRetestReceiptSubmission: null,
      });
      const result = await this.getSampleResults();
      if (result) {
        const { sampleResultsData, isInProcess, totalSlides } = result;
        this.setState({
          sampleResultsData,
          isInProcess,
          totalSlides,
          currentSlide: 0,
          activeDate: sampleResultsData.data[0][0],
          reportPath: sampleResultsData?.report_path,
        });
      }
    } else {
      toast.error(response.message || "Retest request has failed.");
      this.setState({
        awaitingRetestRequest: false,
        showRetestModal: false,
      });
    }
  };

  getDateString = (currDate, monthFirst) => {
    const momentDate = moment(new Date(currDate));
    if (!momentDate.isValid()) {
      return currDate;
    }
    if (monthFirst) {
      return `${momentDate.format("MM/DD/YY")}`;
    }
    return `${momentDate.format("DD MMM YYYY")}`;
  };

  getDisplayedSampleId = () => {
    const { displaySampleIdOverride, sampleResultsData } = this.state;
    const { reportData } = this.props;
    if (displaySampleIdOverride) {
      return displaySampleIdOverride;
    }

    return getPreferredEditedSampleId(sampleResultsData)
      || resolveDisplaySampleId(reportData);
  };

  sampleHasSampleIdEditHistory = () => {
    const { sampleResultsData, hasSampleIdEditHistoryOverride } = this.state;
    const { reportData } = this.props;
    if (hasSampleIdEditHistoryOverride) {
      return true;
    }
    return hasSampleIdEditHistory(sampleResultsData) || hasSampleIdEditHistory(reportData);
  };

  showEditSampleIdModal = async () => {
    const { reportData } = this.props;
    const { sampleResultsData } = this.state;

    if (!hasSentFinalResults(sampleResultsData)) {
      return;
    }

    const hasEditHistory = this.sampleHasSampleIdEditHistory();

    if (!hasEditHistory) {
      this.setState({
        showEditSampleIdModal: true,
        sampleIdEditHistoryForEdit: [],
      });
      return;
    }

    try {
      const receivedDate = reportData.received_date
        ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
        : "";

      const response = await getSampleIdEditHistory({
        sample_id: reportData.sample_id,
        sample_type: reportData.sample_type || "Product",
        received_date: receivedDate,
      });

      if (!response.success) {
        toast.error(response.message);
        return;
      }

      this.setState({
        showEditSampleIdModal: true,
        sampleIdEditHistoryForEdit: response.history,
      });
    } catch (error) {
      toast.error(error.message || "Failed to load sample ID edit history");
    }
  };

  hideEditSampleIdModal = () => {
    this.setState({
      showEditSampleIdModal: false,
      sampleIdEditHistoryForEdit: [],
    });
  };

  handleSampleIdEditSaveSuccess = (newSampleId) => {
    this.setState({
      showEditSampleIdModal: false,
      displaySampleIdOverride: newSampleId,
      hasSampleIdEditHistoryOverride: true,
    });
    this.reportDataRefresh();
  };

  showSampleIdChangeHistoryModal = () => {
    this.setState({ showSampleIdChangeHistoryModal: true });
  };

  hideSampleIdChangeHistoryModal = () => {
    this.setState({ showSampleIdChangeHistoryModal: false });
  };

  isUnitColumnVisible = () => {
    const { sampleSubmission, sampleCategory } = this.props;
    const { sampleResultsData } = this.state;
    // Don't show if unit conversion is disabled for this company
    return !sampleSubmission
      && sampleCategory !== "environment"
      && hasSentFinalResults(sampleResultsData)
      && hasPermission(permissions.product.editResultUnit);
  };

  canConvertUnits = () => {
    const {
      isPickingRetests,
      isPickingPartialGenerate,
      showDetailedPesticideReport,
    } = this.state;
    const { disableInteraction } = this.props;

    return this.isUnitColumnVisible()
      && !disableInteraction
      && !isPickingRetests
      && !isPickingPartialGenerate
      && !showDetailedPesticideReport;
  };

  sampleHasUnitConversionHistory = () => {
    const { sampleResultsData } = this.state;
    const { reportData } = this.props;
    return hasUnitConversionHistory(sampleResultsData) || hasUnitConversionHistory(reportData);
  };

  sampleHasUnitConversionHistoryForCoa = () => {
    const { hasUnitConversionHistoryOverride } = this.state;
    if (hasUnitConversionHistoryOverride) {
      return true;
    }
    return this.sampleHasUnitConversionHistory();
  };

  canSetUnitsToDefault = () => this.sampleHasUnitConversionHistory();

  getUnitConversionDate = (testDate) => {
    const { sampleResultsData } = this.state;
    const oldestDate = this.getOldestReportDate(sampleResultsData);

    if (!testDate || testDate === oldestDate) {
      return "";
    }

    return moment(testDate, "MM/DD/YYYY").format("YYYY-MM-DD");
  };

  openConvertUnitModal = (item, testDate) => {
    if (!this.canConvertUnits()) {
      return;
    }
    if (isUnitConversionUnavailableForMissingSpecUnit({
      currentSpec: item?.specs,
      specUnit: item?.specUnit,
      testCategory: item?.test_category,
    })) {
      return;
    }

    this.setState({
      showConvertUnitModal: true,
      convertUnitRow: {
        test: item.test,
        testCategory: item.test_category || "",
        hasTestDetail: Boolean(item.detail),
        testDetailType: item.detailType || "",
        result: item.result,
        specs: item.specs,
        unit: item.unit || "",
        specUnit: item.specUnit || "",
        retestSampleUsid: item.retestSampleUsid || "",
        testDate,
      },
    });
  };

  hideConvertUnitModal = () => {
    this.setState({
      showConvertUnitModal: false,
      convertUnitRow: null,
    });
  };

  handleConvertUnitUpdate = async ({
    test, testDate, result, specs, unit,
  }) => {
    const { reportData } = this.props;
    const { convertUnitRow } = this.state;
    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : "";
    const retestSampleUsid = convertUnitRow?.retestSampleUsid || "";

    this.setState({ isSavingUnitConversion: true });

    try {
      const response = await saveUnitConversionResult({
        sample_id: reportData.sample_id,
        sample_type: reportData.sample_type || "Product",
        received_date: receivedDate,
        test,
        date: retestSampleUsid ? "" : this.getUnitConversionDate(testDate),
        retest_sample_usid: retestSampleUsid,
        converted_result: result,
        converted_spec: specs,
        converted_unit: unit,
      });

      if (!response.success) {
        this.hideConvertUnitModal();
        toast.error(response.message || "Failed to save unit conversion");
        return;
      }

      this.hideConvertUnitModal();
      toast.success(`Unit is converted to ${unit}`);
      this.setState({ hasUnitConversionHistoryOverride: true });
      this.reportDataRefresh();
    } catch (error) {
      this.hideConvertUnitModal();
      toast.error(error.message || "Failed to save unit conversion");
    } finally {
      this.setState({ isSavingUnitConversion: false });
    }
  };

  confirmSetUnitsToDefault = async (testDate) => {
    const { isResettingUnitsToDefault } = this.state;
    if (!this.canSetUnitsToDefault() || isResettingUnitsToDefault) {
      return false;
    }

    const { reportData } = this.props;
    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : "";

    this.setState({ isResettingUnitsToDefault: true });

    try {
      const response = await setUnitsToDefault({
        sample_id: reportData.sample_id,
        sample_type: reportData.sample_type || "Product",
        received_date: receivedDate,
        date: this.getUnitConversionDate(testDate),
      });

      if (!response.success) {
        toast.error(response.message || "Failed to restore units to default");
        return false;
      }

      toast.success("Units restored to default");
      this.setState({ hasUnitConversionHistoryOverride: false });
      this.reportDataRefresh();
      return true;
    } catch (error) {
      toast.error(error.message || "Failed to restore units to default");
      return false;
    } finally {
      this.setState({ isResettingUnitsToDefault: false });
    }
  };

  getDisplayedSampleType = () => {
    const { displaySampleTypeOverride, sampleResultsData } = this.state;
    const { reportData } = this.props;
    if (displaySampleTypeOverride) {
      return displaySampleTypeOverride;
    }

    return getPreferredEditedSampleType(sampleResultsData)
      || resolveDisplaySampleType(reportData);
  };

  sampleHasSampleTypeEditHistory = () => {
    const { sampleResultsData, hasSampleTypeEditHistoryOverride } = this.state;
    const { reportData } = this.props;
    if (hasSampleTypeEditHistoryOverride) {
      return true;
    }
    return hasSampleTypeEditHistory(sampleResultsData) || hasSampleTypeEditHistory(reportData);
  };

  startSampleTypeEdit = () => {
    const { sampleResultsData } = this.state;
    if (!hasSentFinalResults(sampleResultsData)) {
      return;
    }

    this.setState({
      isEditingSampleType: true,
      sampleTypeDraft: this.getDisplayedSampleType(),
    });
  };

  cancelSampleTypeEdit = () => {
    this.setState({
      isEditingSampleType: false,
      sampleTypeDraft: "",
    });
  };

  handleSampleTypeDraftChange = (event) => {
    this.setState({ sampleTypeDraft: event.target.value });
  };

  handleSampleTypeDraftKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.saveSampleTypeEdit();
      return;
    }
    if (event.key === "Escape") {
      event.preventDefault();
      this.cancelSampleTypeEdit();
    }
  };

  saveSampleTypeEdit = async () => {
    const { reportData } = this.props;
    const { sampleTypeDraft, savingSampleType } = this.state;

    if (savingSampleType) {
      return;
    }

    const trimmedSampleType = (sampleTypeDraft || "").trim();
    if (!trimmedSampleType) {
      toast.error("Sample Type is required");
      return;
    }
    if (trimmedSampleType.length > CHAR_LIMITS.sample_type) {
      toast.error("Sample Type is too long");
      return;
    }
    if (trimmedSampleType === this.getDisplayedSampleType()) {
      this.cancelSampleTypeEdit();
      return;
    }

    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY/MM/DD")
      : "";

    this.setState({ savingSampleType: true });

    try {
      const response = await saveSampleTypeEditHistory({
        sample_id: reportData.sample_id,
        sample_type: reportData.sample_type || "Product",
        received_date: receivedDate,
        new_sample_type: trimmedSampleType,
      });

      if (!response.success) {
        toast.error(response.message);
        return;
      }

      toast.success("Sample Type updated successfully");
      this.setState({
        isEditingSampleType: false,
        sampleTypeDraft: "",
        displaySampleTypeOverride: trimmedSampleType,
        hasSampleTypeEditHistoryOverride: true,
      });
      this.reportDataRefresh();
    } catch (error) {
      toast.error(error.message || "Failed to save Sample Type edit");
    } finally {
      this.setState({ savingSampleType: false });
    }
  };

  showSampleTypeChangeHistoryModal = () => {
    this.setState({ showSampleTypeChangeHistoryModal: true });
  };

  hideSampleTypeChangeHistoryModal = () => {
    this.setState({ showSampleTypeChangeHistoryModal: false });
  };

  getEditedCoaFilePaths = () => {
    const { sampleResultsData } = this.state;
    return resolveModalCoaFilePaths(sampleResultsData);
  };

  showCoaPreviewModal = () => {
    if (!this.getEditedCoaFilePaths()) {
      toast.error("Preview not available. No report file found.");
      return;
    }
    this.setState({ showCoaPreview: true });
  };

  hideCoaPreviewModal = () => {
    this.setState({ showCoaPreview: false });
  };

  downloadCoaFilePaths = async (filePaths) => {
    const filePathList = flattenCoaFilePaths(filePaths);
    if (filePathList.length === 0) {
      return { successCount: 0, totalCount: 0 };
    }

    const downloadResults = await Promise.allSettled(
      filePathList.map((filePath) => {
        const fileName = filePath.split("/").pop();
        const isPrivateS3Bucket = filePath.includes("COAs/");
        return downloadFileFromS3WithPresigned(
          [filePath],
          isPrivateS3Bucket ? "private" : "public",
          [fileName],
        );
      }),
    );

    const successCount = downloadResults.filter(
      (result) => result.status === "fulfilled" && result.value,
    ).length;

    return { successCount, totalCount: filePathList.length };
  };

  handleDownloadCoa = async () => {
    const editedCoaFilePaths = this.getEditedCoaFilePaths();
    const { loadingCoaDownload } = this.state;

    if (!editedCoaFilePaths) {
      toast.error("Unable to download, no valid file path for this report!");
      return;
    }

    if (loadingCoaDownload) {
      return;
    }

    this.setState({ loadingCoaDownload: true });

    try {
      const { successCount, totalCount } = await this.downloadCoaFilePaths(editedCoaFilePaths);

      if (successCount === totalCount && totalCount > 0) {
        toast.success(`Successfully downloaded ${successCount}/${totalCount} files.`);
      } else if (successCount > 0) {
        toast.warning(`Downloaded ${successCount}/${totalCount} files.`);
      } else {
        toast.error("Failed to download COA");
      }
    } catch (error) {
      toast.error(error.message || "Failed to download COA");
    } finally {
      this.setState({ loadingCoaDownload: false });
    }
  };

  /**
   * Regenerate edited-label COA via partialreport + report_sample_id.
   * Uses live sample_id for lookup; display ID goes in report_sample_id only.
   * No auto-download — user previews/downloads after refresh.
   */
  handleRegenerateCoa = async () => {
    const { reportData } = this.props;
    const { sampleResultsData, loadingRegenerateCoa } = this.state;

    if (loadingRegenerateCoa || !hasSentFinalResults(sampleResultsData)) {
      return;
    }

    const reportSampleId = this.getDisplayedSampleId();
    const reportDates = sampleResultsData.data.map(([date]) => date);

    if (reportDates.length === 0) {
      toast.error("Cannot regenerate COA without report dates.");
      return;
    }

    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : null;

    const requestList = reportDates.map((date) => ({
      sample_id: reportData.sample_id,
      sample_type: reportData.sample_type || "Product",
      received_date: receivedDate,
      date: moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
      report_sample_id: reportSampleId,
      report_sample_type: this.getDisplayedSampleType() || reportData.sample_type || "Product",
    }));

    this.setState({ loadingRegenerateCoa: true });

    try {
      const response = await generatePartialReport({
        request_list: requestList,
        skipAutoDownload: true,
      });

      if (!response.success) {
        toast.error(response.message);
        return;
      }

      toast.success("COA regenerated successfully.");
      this.reportDataRefresh();
    } catch (error) {
      toast.error("Failed to regenerate COA.");
    } finally {
      this.setState({ loadingRegenerateCoa: false });
    }
  };

  renderSampleIdActionsMenu = () => {
    const { sampleSubmission, sampleCategory, disableInteraction } = this.props;
    const { sampleResultsData } = this.state;

    // Template/Customized COA and sample submission: no Sample ID three-dots
    // Account-level permission required to show any Sample ID actions
    if (
      disableInteraction
      || sampleSubmission
      || sampleCategory === "environment"
      || !hasPermission(permissions.product.editSampleId)
    ) {
      return null;
    }

    const sampleHasEditHistory = this.sampleHasSampleIdEditHistory();
    const showEditSampleId = canEditSampleId() && hasSentFinalResults(sampleResultsData);

    if (!showEditSampleId && !sampleHasEditHistory) {
      return null;
    }

    return (
      <div className="SampleResultsModal__SampleIDActions">
        <SampleIdActionsMenu
          showEditSampleId={showEditSampleId}
          onEditSampleId={showEditSampleId ? this.showEditSampleIdModal : undefined}
          onViewHistory={this.showSampleIdChangeHistoryModal}
          showViewHistory={sampleHasEditHistory}
        />
      </div>
    );
  };

  // renderEditedSampleIdSuffix = () => {
  //   const { sampleCategory } = this.props;
  //
  //   if (sampleCategory === "environment" || !this.sampleHasSampleIdEditHistory()) {
  //     return null;
  //   }
  //
  //   return (
  //     <span className="SampleResultsModal__EditedSuffix">
  //       {"\u00A0(Edited)"}
  //     </span>
  //   );
  // };

  renderDisplayedSampleId = () => (
    <span>
      {this.getDisplayedSampleId()}
      {/* {this.renderEditedSampleIdSuffix()} */}
    </span>
  );

  renderSampleTypeActionsMenu = () => {
    const { sampleSubmission, sampleCategory, disableInteraction } = this.props;
    const { sampleResultsData, isEditingSampleType } = this.state;

    if (
      disableInteraction
      || sampleSubmission
      || sampleCategory === "environment"
      || isEditingSampleType
      || !hasPermission(permissions.product.editSampleType)
    ) {
      return null;
    }

    const sampleHasEditHistory = this.sampleHasSampleTypeEditHistory();
    const showEditSampleType = canEditSampleType() && hasSentFinalResults(sampleResultsData);

    if (!showEditSampleType && !sampleHasEditHistory) {
      return null;
    }

    let onEditSampleType;
    if (showEditSampleType) {
      onEditSampleType = this.startSampleTypeEdit;
    }

    return (
      <div className="SampleResultsModal__SampleIDActions">
        <SampleIdActionsMenu
          editLabel="Edit Sample Type"
          showEditSampleId={showEditSampleType}
          onEditSampleId={onEditSampleType}
          onViewHistory={this.showSampleTypeChangeHistoryModal}
          showViewHistory={sampleHasEditHistory}
        />
      </div>
    );
  };

  renderSampleTypeEdit = () => {
    const { sampleTypeDraft, savingSampleType } = this.state;

    return (
      <div className="SampleResultsModal__SampleTypeEdit">
        <Input
          className="SampleResultsModal__SampleTypeInput"
          value={sampleTypeDraft}
          onChange={this.handleSampleTypeDraftChange}
          onKeyDown={this.handleSampleTypeDraftKeyDown}
          maxLength={CHAR_LIMITS.sample_type}
          placeholder="Sample Type"
          disabled={savingSampleType}
          autoFocus
        />
        <button
          type="button"
          className="SampleResultsModal__SampleTypeEditAction"
          aria-label="Save Sample Type"
          onClick={this.saveSampleTypeEdit}
          disabled={savingSampleType}
        >
          <CheckOutlined className="SampleResultsModal__SampleTypeEditActionIcon SampleResultsModal__SampleTypeEditActionIcon--save" />
        </button>
        <button
          type="button"
          className="SampleResultsModal__SampleTypeEditAction"
          aria-label="Cancel Sample Type edit"
          onClick={this.cancelSampleTypeEdit}
          disabled={savingSampleType}
        >
          <CloseOutlined className="SampleResultsModal__SampleTypeEditActionIcon SampleResultsModal__SampleTypeEditActionIcon--cancel" />
        </button>
      </div>
    );
  };

  renderSampleTypeDisplay = () => {
    const displayedSampleType = this.getDisplayedSampleType() || "-";

    return (
      <>
        <span className="SampleResultsModal__SampleTypeValue">
          {displayedSampleType}
        </span>
        {this.renderSampleTypeActionsMenu()}
      </>
    );
  };

  renderPhysicalCategory = () => {
    const { reportData } = this.props;
    // TODO: Remove this /reports fallback once physical_category is returned by /reportspecs
    const physicalCategory = reportData?.physical_category || "-";

    return (
      <span className="SampleResultsModal__PhysicalCategory">
        <span className="SampleResultsModal__PhysicalCategoryLabel">
          Physical Category
        </span>
        <span>{physicalCategory}</span>
      </span>
    );
  };

  renderSampleTypeRow = () => {
    const { isEditingSampleType } = this.state;
    let sampleTypeContent;
    if (isEditingSampleType) {
      sampleTypeContent = this.renderSampleTypeEdit();
    } else {
      sampleTypeContent = this.renderSampleTypeDisplay();
    }

    return (
      <div className="SampleResultsModal__SubHeader__Bottom SampleResultsModal__SubHeader__Entry SampleResultsModal__SubHeader__SampleTypeRow">
        <div className="SampleResultsModal__SampleTypeLeft">
          <span className="SampleResultsModal__SubHeader__Label">
            Sample Type
          </span>
          {sampleTypeContent}
        </div>
        {this.renderPhysicalCategory()}
      </div>
    );
  };

  handleDateChanged = (date, index, change = 0) => {
    const {
      currentSlide, totalSlides, sampleResultsData, activeDate, isPickingRetests,
    } = this.state;

    let nextDate = date;
    let nextSlide = index;
    if (!date) {
      const newValue = currentSlide + change;
      if (newValue < totalSlides && newValue >= 0) {
        nextDate = sampleResultsData.data[newValue][0];
        nextSlide = newValue;
      } else {
        return;
      }
    }

    if (nextDate === activeDate && nextSlide === currentSlide) {
      return;
    }

    if (nextDate !== activeDate && isPickingRetests) {
      this.resetRequestRetestSelection({
        activeDate: nextDate,
        currentSlide: nextSlide,
      });
      return;
    }

    if (this.testResultTableRefs.current) {
      this.testResultTableRefs.current.forEach((table) => table?.clearCheckboxes());
    }
    this.setState({
      activeDate: nextDate,
      currentSlide: nextSlide,
      reviewSelectedTests: [],
    });
  };

  handleCarouselChange = (index) => {
    const { currentSlide, sampleResultsData } = this.state;
    if (index === currentSlide) {
      return;
    }
    const slideData = sampleResultsData?.data?.[index];
    if (slideData) {
      this.handleDateChanged(slideData[0], index);
    }
  };

  addTestToRetest = (test, isChecked) => {
    const { testToRetest } = this.state;

    // Need to add to the list
    if (isChecked) {
      testToRetest.push(test);
    } else {
      // Need to remove from the list (don't filter all in case there are duplicates)
      const idxToRemove = testToRetest.findIndex(
        (existingTest) => existingTest === test,
      );
      testToRetest.splice(idxToRemove, 1);
    }

    this.setState({
      testToRetest: [...testToRetest], // make a shallow copy to trigger rerender
    });
  };

  addTestToPartialGenerate = (test, isChecked, date) => {
    const { testsForPartialGenerate, sampleResultsData } = this.state;

    // Store as "date|test" to handle same test on multiple dates
    const testKey = date ? `${date}|${test}` : test;

    // Check if this date has "regular" report in report_path - don't allow adding if true
    // Only block if "regular" exists, not other report types like "pesticides"
    if (isChecked && date && sampleResultsData?.report_path) {
      const reportPath = sampleResultsData.report_path || {};
      if (reportPath[date]) {
        // Check specifically for "regular" key with files
        const hasRegular = reportPath[date].regular
          && Array.isArray(reportPath[date].regular)
          && reportPath[date].regular.length > 0;
        if (hasRegular) {
          // Date has regular report, don't add this test
          return;
        }
      }
    }

    // Need to add to the list
    if (isChecked) {
      testsForPartialGenerate.push(testKey);
    } else {
      // Need to remove from the list (find exact match for date|test combination)
      const idxToRemove = testsForPartialGenerate.findIndex(
        (existingTest) => existingTest === testKey,
      );
      if (idxToRemove !== -1) {
        testsForPartialGenerate.splice(idxToRemove, 1);
      }
    }

    this.setState({
      testsForPartialGenerate: [...testsForPartialGenerate], // make a shallow copy to trigger rerender
    });
  };

  /**
   * Clear Request Retest selection and close any open retest modals.
   * @param {Object} additionalState optional state to merge (e.g. activeDate on tab change)
   */
  resetRequestRetestSelection = (additionalState) => {
    /** For each table, clear selected tests */
    if (this.testResultTableRefs.current) {
      this.testResultTableRefs.current.forEach((table) => table?.clearCheckboxes());
    }
    this.setState({
      isPickingRetests: false,
      testToRetest: [],
      showRetestMethodModal: false,
      showRetestModal: false,
      showNewSampleDatePicker: false,
      showNewSampleConfirmation: false,
      newSampleDate: null,
      ...additionalState,
    });
  };

  /**
   * If entering request retest mode, refresh spec data.
   * @param {Boolean} isPickingRetests true if entering request retest mode, false if canceling out of it
   */
  updateRequestRetestMode = async (isPickingRetests) => {
    const { lockResults } = this.props;
    if (lockResults && isPickingRetests) {
      return;
    }

    if (isPickingRetests && this.hasPendingRetestSubmission()) {
      return;
    }
    if (isPickingRetests && this.hasUnderReviewTab()) {
      return;
    }

    const { testToRetest } = this.state;

    const updatedTests = testToRetest;

    if (isPickingRetests) {
      this.setState({ loadingUpdatedData: true });
      const result = await this.getSampleResults();
      if (result) {
        const { sampleResultsData, isInProcess, totalSlides } = result;
        const { activeDate, keyOfTestResultTable } = this.state;
        const sortedDates = sampleResultsData.data.map(([date, _]) => date); // eslint-disable-line no-unused-vars
        const activeDateIndex = sortedDates.indexOf(activeDate);
        const newSlide = activeDateIndex > -1 ? activeDateIndex : 0;
        const newActiveDate = sortedDates[newSlide];
        this.setState({
          sampleResultsData,
          totalSlides,
          isInProcess,
          // isOutOfSpec,
          // isRetest,
          isPickingRetests: true,
          currentSlide: newSlide,
          activeDate: newActiveDate,
          keyOfTestResultTable: !keyOfTestResultTable,
          loadingUpdatedData: false,
          reportPath: sampleResultsData?.report_path,
          resultsReviewTab: "results",
        });
      } else {
        // if not successful, we need to update state here
        this.setState({
          isPickingRetests: true,
          testToRetest: updatedTests,
          loadingUpdatedData: false,
          resultsReviewTab: "results",
        });
      }
      this.setState({ loadingUpdatedData: false });
    } else {
      // User is exiting the selection mode so reset the state
      this.resetRequestRetestSelection();
    }
  };

  showRequestRetestModal = () => {
    const { awaitingRetestRequest } = this.state;
    if (awaitingRetestRequest || this.hasPendingRetestSubmission()) {
      return;
    }
    this.setState({
      showRetestModal: true,
    });
  };

  hideRequestRetestModal = () => {
    this.setState({
      showRetestModal: false,
    });
  };

  openRetestMethodModal = () => {
    const { awaitingRetestRequest, awaitingNewSampleRequest } = this.state;
    if (awaitingRetestRequest || awaitingNewSampleRequest || this.hasPendingRetestSubmission()) {
      return;
    }
    this.setState({ showRetestMethodModal: true });
  };

  handleRetestMethodContinue = (method) => {
    if (method === "existing_sample") {
      this.setState({ showRetestMethodModal: false });
      this.showRequestRetestModal();
    } else if (method === "new_sample") {
      this.setState({ showRetestMethodModal: false, showNewSampleDatePicker: true });
    }
  };

  handleCancelRetestMethod = () => {
    this.setState({ showRetestMethodModal: false });
  };

  handleNewSampleDateContinue = (date) => {
    this.setState({
      showNewSampleDatePicker: false,
      newSampleDate: date,
      showNewSampleConfirmation: true,
    });
  };

  handleCancelNewSampleDate = () => {
    this.setState({ showNewSampleDatePicker: false, showRetestMethodModal: true });
  };

  handleCancelNewSampleConfirmation = () => {
    this.setState({ showNewSampleConfirmation: false, showNewSampleDatePicker: true });
  };

  buildNewSampleRetestReceiptSubmission = (scheduleDate, tests, submissionId) => {
    const {
      reportData, linkReportJsonFields, fields, sampleFieldsData,
    } = this.props;

    let submitName = reportData.sample_id || "Retest Submission";
    if (sampleFieldsData?.length) {
      const namedField = sampleFieldsData.find((item) => item.value);
      if (namedField) submitName = namedField.value;
    } else if (linkReportJsonFields?.length && fields?.length) {
      const nameKey = linkReportJsonFields.find((key) => reportData[key]);
      if (nameKey) submitName = reportData[nameKey];
    }

    const now = moment();
    const submitMoment = scheduleDate
      ? scheduleDate.clone().hour(now.hour()).minute(now.minute()).second(now.second())
      : now;

    const tests_list = Array.from(new Set(tests)).map((test) => ({ test_name: test }));

    return {
      samples_list: [{
        sample_id: reportData.sample_id,
        tests_list,
      }],
      num_samples: 1,
      submit_date: submitMoment.format(),
      submit_name: submitName,
      po: "",
      comment: "",
      submit_id: submissionId || submitName,
    };
  };

  handleNewSampleRetestRequest = async () => {
    const { testToRetest, newSampleDate } = this.state;
    const { reportData } = this.props;

    this.setState({ awaitingNewSampleRequest: true });

    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : "";
    const scheduledDate = newSampleDate && !newSampleDate.isSame(moment(), "day")
      ? newSampleDate.format("YYYY-MM-DD")
      : "";
    const parentSampleUniqueIdentifier = reportData.sample_unique_identifier || "";
    const payload = {
      parent_submission_id: reportData.submission_id || "",
      parent_sample_unique_identifier: parentSampleUniqueIdentifier,
      tests_selected: Array.from(new Set(testToRetest)),
      scheduled_date: scheduledDate,
      send_new_sample: "result",
    };

    if (!parentSampleUniqueIdentifier) {
      payload.parent_sample_id = reportData.sample_id || "";
      payload.parent_sample_type = reportData.sample_type || "";
      payload.parent_received_date = receivedDate;
    }

    const response = await requestRetestNewSample(payload);
    if (response && response.success) {
      const receiptSubmission = this.buildNewSampleRetestReceiptSubmission(
        newSampleDate,
        testToRetest,
        response.submissionId,
      );
      if (this.testResultTableRefs.current) {
        this.testResultTableRefs.current.forEach((table) => table?.clearCheckboxes());
      }
      this.setState({
        showNewSampleConfirmation: false,
        showNewSampleDatePicker: false,
        showRetestMethodModal: false,
        newSampleDate: null,
        awaitingNewSampleRequest: false,
        isPickingRetests: false,
        testToRetest: [],
        showNewSampleRetestSuccess: true,
        newSampleRetestSuccessDate: newSampleDate,
        newSampleRetestReceiptSubmission: receiptSubmission,
      });
      const result = await this.getSampleResults();
      if (result) {
        const { sampleResultsData, isInProcess, totalSlides } = result;
        this.setState({
          sampleResultsData,
          isInProcess,
          totalSlides,
          currentSlide: 0,
          activeDate: sampleResultsData.data[0][0],
          reportPath: sampleResultsData?.report_path,
        });
      }
    } else {
      toast.error(response.message || "New sample retest request has failed.");
      this.setState({
        awaitingNewSampleRequest: false,
        showNewSampleConfirmation: false,
      });
    }
  };

  handleNewSampleRetestSuccessDone = () => {
    const { newSampleRetestReceiptSubmission } = this.state;
    if (newSampleRetestReceiptSubmission) {
      this.setState({
        showNewSampleRetestSuccess: false,
        newSampleRetestSuccessDate: null,
        showNewSampleRetestReceipt: true,
      });
      return;
    }

    this.setState({
      showNewSampleRetestSuccess: false,
      newSampleRetestSuccessDate: null,
      testToRetest: [],
    });
  };

  handleNewSampleRetestReceiptClose = () => {
    this.setState({
      showNewSampleRetestReceipt: false,
      newSampleRetestReceiptSubmission: null,
      isPickingRetests: false,
      testToRetest: [],
      reviewNewSampleSuccessHeading: "Retest Request created for",
    });
  };

  // eslint-disable-next-line consistent-return
  handleCloseModal = () => {
    const {
      handleExitSampleResultsModal, reportData, sampleSubmission, onCancel,
    } = this.props;
    if (sampleSubmission) return onCancel();
    const { sampleResultsData } = this.state;
    const specsFlagHasChanged = sampleResultsData?.specs_flag && sampleResultsData.specs_flag !== reportData.specs_flag;
    handleExitSampleResultsModal(specsFlagHasChanged ? sampleResultsData.specs_flag : undefined);
  }

  /**
   * Show and hide pesticide details toggle
   * @param {boolean} isOpen is open
   */
  handlePesticideDetailsToggle = (isOpen, test) => {
    const { lockResults } = this.props;
    if (lockResults && isOpen) {
      return;
    }
    this.setState((state) => ({ ...state, showDetailedPesticideReport: isOpen, pesticideDetailTest: test }));
  }

  /**
   * Checks whether a date has a pesticide report
   * @param {*} sampleResultsData Sample result data
   * @returns Object containing date as key and value as true/false.
   */
  checkPesticideTestByDate = (sampleResultsData) => Object.keys(sampleResultsData.report_result).reduce((acc, key) => {
    const testList = sampleResultsData.report_result[key];
    let testHasPesticide = false;
    testList.forEach((test) => {
      if (test.test.test_category === "MRL") {
        testHasPesticide = true;
      }
    });
    acc[key] = testHasPesticide;
    return acc;
  }, {});

  /**
   * Set pesticide commodity value
   * @param {*} value commodity value
   * //NOTE: Kept for future as value is not being shown
   */
  // setPesticideCommodity = (value) => this.setState({ pesticideCommodity: value });

  getRequestRetestTooltip = ({
    awaitingRetestRequest,
    atMaxRetests = false,
    finalsSent = true,
    hasUnderReviewTab = false,
  } = {}) => {
    if (awaitingRetestRequest) {
      return "Awaiting request";
    }
    if (hasUnderReviewTab) {
      return "Cannot request retest while tests are under review";
    }
    if (this.hasPendingRetestSubmission()) {
      const dateText = this.getNewSampleRetestBannerDateText();
      if (dateText) {
        return `Cannot request retest. Sample to be submitted on ${dateText}.`;
      }
      return "Cannot request retest while a new sample submission is pending.";
    }
    if (atMaxRetests) {
      return `Max amount of retests (${MAX_RETESTS_ALLOWED}) reached`;
    }
    if (!finalsSent) {
      return "Cannot request retest until final results have been sent";
    }
    return "";
  };

  shouldShowOosReviewTabs = (dataOverride) => {
    const { sampleCategory, disableInteraction, sampleSubmission } = this.props;
    const {
      isPickingRetests,
      isPickingPartialGenerate,
      showDetailedPesticideReport,
      sampleResultsData,
    } = this.state;
    const data = dataOverride || sampleResultsData;
    return !sampleSubmission
      && sampleCategory !== "environment"
      && !disableInteraction
      && !isPickingRetests
      && !isPickingPartialGenerate
      && !showDetailedPesticideReport
      && sampleHasResultsReviewTabs(data);
  };

  hasUnderReviewTab = () => {
    const { sampleResultsData, activeDate } = this.state;
    if (!this.shouldShowOosReviewTabs() || !sampleResultsData?.data?.length) {
      return false;
    }
    const entry = sampleResultsData.data.find(([date]) => date === activeDate)
      || sampleResultsData.data[0];
    if (!entry) {
      return false;
    }
    const { reviewTests } = this.getOosPartitionForDate(entry[0], entry[1]);
    return reviewTests.length > 0;
  };

  getOosPartitionForDate = (date, tests) => {
    const { pendingRelease } = this.state;
    const partitioned = partitionTestsForOosRelease(tests);
    if (pendingRelease?.date === date && pendingRelease?.test) {
      const alreadyInReview = partitioned.reviewTests.some(
        (item) => item.test === pendingRelease.test,
      );
      if (alreadyInReview) {
        return partitioned;
      }
      const heldTest = partitioned.resultsTests.find((item) => item.test === pendingRelease.test);
      if (heldTest) {
        return {
          reviewTests: [...partitioned.reviewTests, heldTest],
          resultsTests: partitioned.resultsTests.filter((item) => item.test !== pendingRelease.test),
        };
      }
    }
    return partitioned;
  };

  getDefaultResultsReviewTab = (sampleResultsData) => {
    const data = sampleResultsData?.data;
    if (!Array.isArray(data) || !data.length) {
      return "results";
    }
    const firstDateTests = Array.isArray(data[0]?.[1]) ? data[0][1] : [];
    const { reviewTests } = partitionTestsForOosRelease(firstDateTests);
    return reviewTests.length > 0 ? "review" : "results";
  };

  handleResultsReviewTabChange = (tab) => {
    this.setState({ resultsReviewTab: tab, reviewSelectedTests: [] });
  };

  handleReviewSelectionChange = (selectedTests) => {
    this.setState((prev) => {
      const prevKey = (prev.reviewSelectedTests || []).join("|");
      const nextKey = (selectedTests || []).join("|");
      if (prevKey === nextKey) {
        return null;
      }
      return { reviewSelectedTests: selectedTests };
    });
  };

  getContactCsmProductName = () => {
    const { reportData } = this.props;
    return reportData?.item || reportData?.product_name || reportData?.description || "-";
  };

  openContactCsmModal = () => {
    const { reviewSelectedTests } = this.state;
    if (!reviewSelectedTests.length) {
      return;
    }
    this.setState({ showContactCsmModal: true });
  };

  openReviewSendNewSample = () => {
    const { reviewSelectedTests, reviewSendNewSampleLoading } = this.state;
    if (!reviewSelectedTests.length || reviewSendNewSampleLoading) {
      return;
    }

    this.setState({
      testToRetest: [...reviewSelectedTests],
      showSendNewSampleWizard: true,
    });
  };

  getSampleSizeForTests = (testNames) => {
    const { sampleResultsData, activeDate } = this.state;
    const entry = sampleResultsData?.data?.find(([date]) => date === activeDate)
      || sampleResultsData?.data?.[0];
    const tests = (entry?.[1] || []).filter((item) => testNames.includes(item.test));
    return getTotalSampleSize(tests);
  };

  closeSendNewSampleWizard = () => {
    this.setState({
      showSendNewSampleWizard: false,
      testToRetest: [],
    });
  };

  /**
   * Notify the reports table that a review action was taken
   */
  markReviewActionTaken = () => {
    const { toggleReviewActionTaken } = this.props;
    if (toggleReviewActionTaken) {
      toggleReviewActionTaken(true);
    }
  };

  refreshAfterReviewNewSample = async () => {
    const result = await this.getSampleResults();
    if (!result) {
      return;
    }
    const { sampleResultsData, isInProcess, totalSlides } = result;
    this.setState((prev) => ({
      sampleResultsData,
      isInProcess,
      totalSlides,
      currentSlide: 0,
      activeDate: sampleResultsData.data[0][0],
      reportPath: sampleResultsData?.report_path,
      reviewSelectedTests: [],
      resultsReviewTab: "results",
      keyOfTestResultTable: !prev.keyOfTestResultTable,
    }));
  };

  submitReviewSendNewSample = async (selectedDate) => {
    const { testToRetest } = this.state;
    const { reportData } = this.props;
    this.setState({ reviewSendNewSampleLoading: true });

    const scheduledDate = selectedDate
      ? selectedDate.format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

    const receivedDate = reportData.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : "";
    const parentSampleUniqueIdentifier = reportData.sample_unique_identifier || "";
    const payload = {
      parent_submission_id: reportData.submission_id || "",
      parent_sample_unique_identifier: parentSampleUniqueIdentifier,
      tests_selected: Array.from(new Set(testToRetest)),
      scheduled_date: selectedDate && !selectedDate.isSame(moment(), "day")
        ? scheduledDate
        : "",
      send_new_sample: "review",
    };
    if (!parentSampleUniqueIdentifier) {
      payload.parent_sample_id = reportData.sample_id || "";
      payload.parent_sample_type = reportData.sample_type || "";
      payload.parent_received_date = receivedDate;
    }
    const response = await requestRetestNewSample(payload);
    if (response?.success) {
      this.markReviewActionTaken();
      const receiptSubmission = this.buildNewSampleRetestReceiptSubmission(
        selectedDate || moment(scheduledDate),
        testToRetest,
        response.submissionId,
      );
      this.setState({
        reviewSendNewSampleLoading: false,
        showSendNewSampleWizard: false,
        testToRetest: [],
        showNewSampleRetestSuccess: true,
        newSampleRetestSuccessDate: selectedDate || moment(scheduledDate),
        newSampleRetestReceiptSubmission: receiptSubmission,
        reviewNewSampleSuccessHeading: "New Sample Request created for",
      });
      await this.refreshAfterReviewNewSample();
      return;
    }

    this.setState({ reviewSendNewSampleLoading: false });
    toast.error(response?.message || "New sample retest request has failed.");
  };

  closeContactCsmModal = () => {
    const { submittingContactCsm } = this.state;
    if (submittingContactCsm) {
      return;
    }
    this.setState({ showContactCsmModal: false });
  };

  formatApiDate = (dateValue) => {
    if (!dateValue) {
      return "";
    }
    const parsed = moment(
      dateValue,
      ["YYYY-MM-DD", "MM/DD/YYYY", "YYYY/MM/DD", moment.ISO_8601],
      true,
    );
    if (parsed.isValid()) {
      return parsed.format("YYYY-MM-DD");
    }
    const fallback = moment(new Date(dateValue));
    return fallback.isValid() ? fallback.format("YYYY-MM-DD") : "";
  };

  getReceivedDateForApi = () => {
    const { reportData } = this.props;
    return this.formatApiDate(reportData?.received_date);
  };

  buildReviewTestList = (testNames, requestDate) => {
    const apiDate = this.formatApiDate(requestDate);
    const uniqueNames = Array.from(new Set((testNames || []).filter(Boolean)));
    return uniqueNames.map((test) => ({
      test,
      request_date: apiDate,
    }));
  };

  submitContactCsmRequest = async (comment = "") => {
    const { reviewSelectedTests, activeDate } = this.state;
    const { reportData } = this.props;
    if (!reviewSelectedTests.length) {
      return;
    }

    const user = getUserCredentials();

    this.setState({ submittingContactCsm: true });
    const response = await contactCsm({
      sample_id: reportData?.sample_id,
      sample_type: reportData?.sample_type || "Product",
      received_date: this.getReceivedDateForApi(),
      release_result_status: RELEASE_RESULT_STATUS.INVESTIGATION_IN_PROCESS,
      test_list: this.buildReviewTestList(reviewSelectedTests, activeDate),
      comment: (comment || "").toString().trim(),
      contact_csm_requested_by: user?.user_name || user?.user_email || "",
      sample_view_url: typeof window !== "undefined" ? window.location.href : "",
    });

    if (response?.success) {
      this.markReviewActionTaken();
      const refreshed = await this.getSampleResults();
      this.setState((prev) => ({
        submittingContactCsm: false,
        showContactCsmModal: false,
        showContactCsmSuccess: true,
        keyOfTestResultTable: !prev.keyOfTestResultTable,
        reviewSelectedTests: [],
        ...(refreshed ? {
          sampleResultsData: refreshed.sampleResultsData,
          isInProcess: refreshed.isInProcess,
          totalSlides: refreshed.totalSlides,
          reportPath: refreshed.sampleResultsData?.report_path,
        } : {}),
      }));
      return;
    }

    this.setState({ submittingContactCsm: false });
    toast.error(response?.message || "Failed to submit CSM request.");
  };

  closeContactCsmSuccess = () => {
    this.setState({ showContactCsmSuccess: false });
  };

  openReleaseConfirm = (item, date) => {
    if (!isOosReviewSelectable(item)) {
      return;
    }
    this.setState({
      showReleaseConfirm: true,
      testToRelease: item,
      testToReleaseDate: date,
    });
  };

  closeReleaseConfirm = () => {
    const { releasingTest } = this.state;
    if (releasingTest) {
      return;
    }
    this.setState({
      showReleaseConfirm: false,
      testToRelease: null,
      testToReleaseDate: "",
    });
  };

  confirmReleaseTest = async () => {
    const { testToRelease, testToReleaseDate } = this.state;
    const { reportData } = this.props;
    if (!testToRelease) {
      return;
    }

    this.setState({ releasingTest: true });
    const releasePayload = {
      sample_id: reportData?.sample_id,
      sample_type: reportData?.sample_type || "Product",
      received_date: this.getReceivedDateForApi(),
      is_under_review: false,
      test_list: this.buildReviewTestList([testToRelease.test], testToReleaseDate),
    };
    const response = await releaseTestResults(releasePayload);

    if (response?.success) {
      this.markReviewActionTaken();
      this.releaseRefreshPromise = this.getSampleResults();
      this.setState({
        releasingTest: false,
        showReleaseConfirm: false,
        testToRelease: null,
        testToReleaseDate: "",
        showReleaseSuccess: true,
        releasedTestItem: testToRelease,
        pendingRelease: {
          date: testToReleaseDate,
          test: testToRelease.test,
        },
      });
      return;
    }

    this.setState({ releasingTest: false });
    toast.error(response?.message || "Failed to release test results.");
  };

  closeReleaseSuccess = () => {
    const {
      releasedTestItem,
      pendingRelease,
    } = this.state;
    if (this.tabCountBurstTimer) {
      window.clearTimeout(this.tabCountBurstTimer);
    }
    if (this.updateSpecsPromptTimer) {
      window.clearTimeout(this.updateSpecsPromptTimer);
    }
    const showPrompt = shouldOfferUpdateSpecsPrompt(releasedTestItem);
    const releasedDate = showPrompt ? (pendingRelease?.date || "") : "";
    const releasedItem = showPrompt && releasedDate ? releasedTestItem : null;
    const shouldShowPrompt = Boolean(showPrompt && releasedDate);

    this.setState({
      showReleaseSuccess: false,
      pendingRelease: null,
      resultsReviewTab: "results",
      showUpdateSpecsPrompt: false,
      releasedTestItem: releasedItem,
      releasedTestDate: shouldShowPrompt ? releasedDate : "",
      tabCountBurst: null,
      holdResultsReviewTabs: true,
    }, async () => {
      const refreshed = await (this.releaseRefreshPromise || this.getSampleResults());
      this.releaseRefreshPromise = null;
      this.setState({
        ...(refreshed ? {
          sampleResultsData: refreshed.sampleResultsData,
          isInProcess: refreshed.isInProcess,
          totalSlides: refreshed.totalSlides,
          reportPath: refreshed.sampleResultsData?.report_path,
        } : {}),
        holdResultsReviewTabs: true,
        tabCountBurst: { results: 1, token: Date.now() },
      }, () => {
        this.tabCountBurstTimer = window.setTimeout(() => {
          this.setState({
            tabCountBurst: null,
            holdResultsReviewTabs: false,
          });
        }, 1000);
      });

      if (!shouldShowPrompt) {
        return;
      }
      this.updateSpecsPromptOpenAt = Date.now();
      this.updateSpecsPromptTimer = window.setTimeout(() => {
        this.setState({ showUpdateSpecsPrompt: true });
      }, 1000);
    });
  };

  closeUpdateSpecsPrompt = () => {
    if (this.updateSpecsPromptTimer) {
      window.clearTimeout(this.updateSpecsPromptTimer);
      this.updateSpecsPromptTimer = null;
    }
    this.setState({
      showUpdateSpecsPrompt: false,
      releasedTestItem: null,
      releasedTestDate: "",
    });
  };

  handleUpdateSpecsPromptOpenChange = (open) => {
    if (open) {
      return;
    }
    // Ignore outside-click closes for a short window after we programmatically open.
    if (this.updateSpecsPromptOpenAt && Date.now() - this.updateSpecsPromptOpenAt < 400) {
      return;
    }
    this.closeUpdateSpecsPrompt();
  };

  /**
   * Notify QC that specs were not updated for the released test
   */
  sendDontUpdateSpecsNotification = async () => {
    const { reportData } = this.props;
    const { releasedTestItem, releasedTestDate } = this.state;
    if (!releasedTestItem?.test) {
      return;
    }
    const response = await notifyDontUpdateSpecs({
      sample_id: reportData?.sample_id,
      sample_type: reportData?.sample_type || "Product",
      received_date: this.getReceivedDateForApi(),
      test_list: this.buildReviewTestList([releasedTestItem.test], releasedTestDate),
    });
    if (!response?.success) {
      toast.error(response?.message || "Failed to notify QC.");
    }
  };

  handleUpdateSpecsNotNow = () => {
    this.sendDontUpdateSpecsNotification();
    this.closeUpdateSpecsPrompt();
  };

  handleUpdateSpecsDontShowAgain = () => {
    this.sendDontUpdateSpecsNotification();
    hideUpdateSpecsPromptPermanently();
    this.closeUpdateSpecsPrompt();
  };

  handleUpdateSpecsNavigate = () => {
    const { reportData, handleAddSpecsButton } = this.props;
    const { releasedTestItem } = this.state;
    this.closeUpdateSpecsPrompt();
    if (handleAddSpecsButton && reportData?.index_id) {
      handleAddSpecsButton(reportData.index_id, reportData, getSuggestedSpecTest(releasedTestItem));
      return;
    }
    toast.error("Failed to load spec data");
  };

  handleRenderingRequestRetestButton = () => {
    const {
      awaitingRetestRequest,
      isPickingRetests,
      isPickingPartialGenerate,
      testToRetest,
      totalSlides,
      loadingUpdatedData,
      showDetailedPesticideReport,
      sampleResultsData,
      resultsReviewTab,
      // admin,
      // isRetest,
      // isOutOfSpec,
    } = this.state;

    // Don't show if picking partial generate
    if (isPickingPartialGenerate) {
      return null;
    }

    if (resultsReviewTab === "review") {
      return null;
    }

    if (isPickingRetests) {
      const hasPendingSubmission = this.hasPendingRetestSubmission();
      const submitTooltipTitle = this.getRequestRetestTooltip({ awaitingRetestRequest });

      // If user is picking retests we need to render cancel & submit button
      return (
        <div className="SampleResultsModal__PickingRetestsContainer">
          <Button
            type="default"
            onClick={() => this.updateRequestRetestMode(false)}
          >
            Cancel
          </Button>
          <Tooltip
            title={submitTooltipTitle}
            placement="right"
            classNames={{ root: "SampleResultsModal__DarkTooltip" }}
            getPopupContainer={() => document.body}
          >
            <Button
              type="primary"
              disabled={
                testToRetest.length === 0
                || awaitingRetestRequest
                || hasPendingSubmission
                || showDetailedPesticideReport
              }
              onClick={() => this.openRetestMethodModal()}
            >
              Request Retest (
              {new Set(testToRetest).size}
              )
            </Button>
          </Tooltip>
        </div>
      );
    }

    const atMaxRetests = totalSlides - 1 >= MAX_RETESTS_ALLOWED;
    const finalsSent = hasSentFinalResults(sampleResultsData);
    const hasPendingSubmission = this.hasPendingRetestSubmission();
    const hasUnderReviewTab = this.hasUnderReviewTab();
    const { lockResults } = this.props;
    // Allow a retest only once. Hide the button if a retest date already exists
    // or a new-sample retest submission is still pending.
    if (atMaxRetests || hasPendingSubmission) {
      return null;
    }
    if (canRequestProductRetest()) {
      const disableButton = awaitingRetestRequest
        || hasPendingSubmission
        || atMaxRetests
        || !finalsSent
        || loadingUpdatedData
        || showDetailedPesticideReport
        || hasUnderReviewTab
        || lockResults;
      const tooltipTitle = lockResults
        ? ""
        : this.getRequestRetestTooltip({
          awaitingRetestRequest,
          atMaxRetests,
          finalsSent,
          hasUnderReviewTab,
        });
      return (
        <AnimatePresence initial={false}>
          <Tooltip
            title={tooltipTitle}
            placement="right"
            classNames={{ root: "SampleResultsModal__DarkTooltip" }}
            getPopupContainer={() => document.body}
          >
            <Button
              key="request retest button"
              type="primary"
              className="SampleResultsModal__RetestRequestButton"
              disabled={disableButton}
              onClick={
                awaitingRetestRequest || loadingUpdatedData || hasPendingSubmission || hasUnderReviewTab
                  ? () => { }
                  : () => this.updateRequestRetestMode(true)
              }
            >
              <div>
                Request Retest
                {totalSlides > 1 ? ` (${totalSlides - 1}/${MAX_RETESTS_ALLOWED})` : null}
              </div>
            </Button>
          </Tooltip>
        </AnimatePresence>
      );
    }

    return null;
  };

  /**
   * Toggle partial generate selection mode
   * @param {Boolean} isPickingPartialGenerate true if entering selection mode, false if canceling
   */
  updatePartialGenerateMode = async (isPickingPartialGenerate) => {
    const { lockResults } = this.props;
    if (lockResults && isPickingPartialGenerate) {
      return;
    }

    if (isPickingPartialGenerate) {
      // Use existing state data (no API call needed)
      // Clear existing selections when entering partial generate mode
      // Tests will be auto-selected after data loads
      const { sampleResultsData, activeDate, keyOfTestResultTable } = this.state;

      if (!sampleResultsData) {
        return;
      }

      // Ensure disabled tests map is set for partial generate
      this.setTestsToDisableForPartialGenerate(sampleResultsData);

      const sortedDates = sampleResultsData.data.map(([date, _]) => date); // eslint-disable-line no-unused-vars
      const activeDateIndex = sortedDates.indexOf(activeDate);
      const newSlide = activeDateIndex > -1 ? activeDateIndex : 0;
      const newActiveDate = sortedDates[newSlide];

      this.setState({
        testsForPartialGenerate: [],
        isPickingPartialGenerate: true,
        currentSlide: newSlide,
        activeDate: newActiveDate,
        keyOfTestResultTable: !keyOfTestResultTable,
      }, () => {
        // After state is updated and component re-rendered, select all enabled tests by default
        // Tests for dates with report_path will be automatically excluded
        // Use setTimeout to ensure refs are updated after render
        setTimeout(() => {
          if (this.testResultTableRefs.current) {
            this.testResultTableRefs.current.forEach((table) => {
              if (table && typeof table.selectAllEnabledTests === "function") {
                table.selectAllEnabledTests();
              }
            });
          }
          // Remove any tests from dates that have report_path (in case they were already selected)
          this.removeTestsFromDatesWithReports();
        }, 0);
      });
    } else {
      // User is exiting the selection mode so reset the state
      /** For each table, clear selected tests */
      if (this.testResultTableRefs.current) {
        this.testResultTableRefs.current.forEach((table) => table?.clearCheckboxes());
      }
      this.setState({
        isPickingPartialGenerate: false,
        testsForPartialGenerate: [],
      });
    }
  };

  /**
   * Remove tests from dates that have "regular" report in report_path
   * Called after selecting all tests to deselect tests for dates with existing regular reports
   * Only removes tests if "regular" exists, not other report types like "pesticides"
   */
  removeTestsFromDatesWithReports = () => {
    const { testsForPartialGenerate, sampleResultsData } = this.state;

    if (!testsForPartialGenerate.length || !sampleResultsData?.report_path) {
      return;
    }

    const reportPath = sampleResultsData.report_path || {};
    const filteredTests = testsForPartialGenerate.filter((testKey) => {
      const [date] = testKey.split("|");
      if (!date) return true; // Keep if no date found

      // Remove only if date has "regular" report with files
      if (reportPath[date]) {
        const hasRegular = reportPath[date].regular
          && Array.isArray(reportPath[date].regular)
          && reportPath[date].regular.length > 0;
        return !hasRegular; // Keep only if date doesn't have regular report
      }
      return true; // Keep if date doesn't have report_path
    });

    if (filteredTests.length !== testsForPartialGenerate.length) {
      this.setState({ testsForPartialGenerate: filteredTests });
    }
  };

  /**
   * Check if any selected dates already have "regular" report in report_path
   * Disable generate button if any selected date has a "regular" report in the API response
   * Only checks for "regular", not other report types like "pesticides"
   * @returns {boolean} true if any selected date has regular report
   */
  hasSelectedDatesWithReports = () => {
    const { testsForPartialGenerate, sampleResultsData } = this.state;

    if (!testsForPartialGenerate.length || !sampleResultsData?.report_path) {
      return false;
    }

    // Extract unique dates from selected tests (format: "date|test")
    const selectedDates = new Set();
    testsForPartialGenerate.forEach((testKey) => {
      const [date] = testKey.split("|");
      if (date) {
        selectedDates.add(date);
      }
    });

    // Get report_path from API response
    // report_path structure from API: { "11/10/2025": { regular: [...] }, ... }
    const reportPath = sampleResultsData.report_path || {};

    // If no dates selected, return false
    if (selectedDates.size === 0) {
      return false;
    }

    // Check if any selected date has "regular" report in the API response
    let hasAnyDateWithRegularReport = false;

    selectedDates.forEach((date) => {
      // Check specifically for "regular" key with files
      if (reportPath[date]) {
        const hasRegular = reportPath[date].regular
          && Array.isArray(reportPath[date].regular)
          && reportPath[date].regular.length > 0;
        if (hasRegular) {
          hasAnyDateWithRegularReport = true;
        }
      }
    });

    return hasAnyDateWithRegularReport;
  };

  /**
   * Find a test object in sampleResultsData by date and test name
   * @param {string} date - Date string in "MM/DD/YYYY" format
   * @param {string} testName - Name of the test
   * @returns {Object|null} Test object with test_category or null if not found
   */
  findTestInSampleData = (date, testName) => {
    const { sampleResultsData } = this.state;
    if (!sampleResultsData || !sampleResultsData.data) {
      return null;
    }

    // Find the date entry in sampleResultsData.data
    const dateEntry = sampleResultsData.data.find(([dataDate]) => dataDate === date);
    if (!dateEntry) {
      return null;
    }

    // Find the test in the test results array for this date
    const [, testResults] = dateEntry;
    if (!Array.isArray(testResults)) {
      return null;
    }

    const testObj = testResults.find((test) => test.test === testName);
    return testObj || null;
  };

  /**
   * Handle partial generate button click - generate report with selected tests
   */
  handlePartialGenerate = async () => {
    const { lockResults } = this.props;
    if (lockResults) {
      return;
    }

    const { testsForPartialGenerate } = this.state;
    const { reportData } = this.props;

    if (testsForPartialGenerate.length === 0) {
      toast.warning("Please select at least one test to generate partial report.");
      return;
    }

    // Group tests by date (format: "date|test") and store test objects
    const testsByDate = {};
    testsForPartialGenerate.forEach((testKey) => {
      const [date, testName] = testKey.split("|");
      if (date && testName) {
        if (!testsByDate[date]) {
          testsByDate[date] = [];
        }
        // Find the test object from sampleResultsData to get test_category
        const testObj = this.findTestInSampleData(date, testName);
        if (testObj) {
          testsByDate[date].push({
            test: testName,
            test_category: testObj.test_category || "",
          });
        } else {
          // Fallback if test not found (shouldn't happen, but handle gracefully)
          testsByDate[date].push({
            test: testName,
            test_category: "",
          });
        }
      }
    });

    // Build request_list for API
    // received_date is the original date, date is the test date from report_result
    const receivedDate = reportData?.received_date
      ? moment(new Date(reportData.received_date)).format("YYYY-MM-DD")
      : null;

    const requestList = Object.entries(testsByDate).map(([date, testList]) => {
      // Format the date from "MM/DD/YYYY" to "YYYY-MM-DD"
      // This is the date from report_result when the tests were performed
      const formattedDate = moment(date, "MM/DD/YYYY").format("YYYY-MM-DD");

      return {
        sample_id: reportData?.sample_id || "",
        sample_type: reportData?.sample_type || "Product",
        received_date: receivedDate,
        date: formattedDate, // Always send the report_result date
        test_list: testList,
      };
    });

    // Show loading state
    this.setState({ loadingPartialGenerate: true });

    const { sampleCategory } = this.props;

    try {
      const response = await generatePartialReport({ request_list: requestList });

      if (response.success) {
        // Exit selection mode on success
        this.updatePartialGenerateMode(false);
      } else {
        toast.error(response.message || "Failed to generate partial report.");
        // For product, don't reset state on failure - keep selection mode active
        // For environment, exit selection mode (old behavior)
        if (sampleCategory !== "product") {
          this.updatePartialGenerateMode(false);
        }
      }
    } catch (error) {
      toast.error("Failed to generate partial report.");
      // For product, don't reset state on error - keep selection mode active
      // For environment, exit selection mode (old behavior)
      if (sampleCategory !== "product") {
        this.updatePartialGenerateMode(false);
      }
    } finally {
      this.setState({ loadingPartialGenerate: false });
    }
  };

  getOldestReportDate = (sampleResultsData) => {
    if (!sampleResultsData || Object.keys(sampleResultsData?.data).length === 0) return null;
    const sortedDates = sortBy(sampleResultsData?.data, (data) => moment(new Date(data[0])));
    return sortedDates ? sortedDates[0][0] : null;
  };

  getPendingRetestSubmissionDateData = (sampleResultsData) => {
    const { sampleResultsData: stateSampleResultsData } = this.state;
    const data = sampleResultsData ?? stateSampleResultsData;
    const pendingDateData = data?.pending_retest_submission_data;
    if (!pendingDateData || !pendingDateData.date) {
      return null;
    }
    return pendingDateData;
  };

  hasPendingRetestSubmission = () => Boolean(this.getPendingRetestSubmissionDateData());

  shouldShowNewSampleRetestBanner = () => Boolean(this.getPendingRetestSubmissionDateData());

  getNewSampleRetestBannerDateText = () => {
    const data = this.getPendingRetestSubmissionDateData();
    if (!data || !data.date) return "";

    return String(data.date)
      .split(",")
      .map((dateValue) => formatPendingRetestBannerDate(dateValue.trim()))
      .filter(Boolean)
      .join(", ");
  };

  renderNewSampleRetestBanner = () => {
    if (!this.shouldShowNewSampleRetestBanner()) return null;
    const { header, body, date } = this.getPendingRetestSubmissionDateData();
    const formattedDateText = String(date)
      .split(",")
      .map((dateValue) => formatPendingRetestBannerDate(dateValue.trim()))
      .filter(Boolean)
      .join(", ");
    return (
      <div className="SampleResultsModal__NewSampleBanner">
        <InfoCircleOutlined
          className="SampleResultsModal__NewSampleBannerIcon"
          aria-hidden
        />
        <div className="SampleResultsModal__NewSampleBannerContent">
          <span className="SampleResultsModal__NewSampleBannerTitle">
            {`${header?.trim()} ${formattedDateText}.`}
          </span>
          <span className="SampleResultsModal__NewSampleBannerSupporting">
            {body}
          </span>
        </div>
      </div>
    );
  };

  /**
   * Check if ALL tests in report_result have test_category === "MRL"
   * @returns {boolean} true if all tests are MRL, false otherwise
   */
  areAllTestsMRL = () => {
    const { sampleResultsData } = this.state;

    if (!sampleResultsData || !sampleResultsData.data || !Array.isArray(sampleResultsData.data)) {
      return false;
    }

    // Flatten all tests from all dates and check if all have test_category === "MRL"
    const allTests = sampleResultsData.data.flatMap(([, testResults]) => testResults);

    // If no tests, return false
    if (allTests.length === 0) {
      return false;
    }

    // Return true only if ALL tests have test_category === "MRL"
    return allTests.every((test) => test.test_category === "MRL");
  };

  /**
   * Check if all report_result dates have "regular" report in report_path
   * @returns {boolean} true if all dates have regular report_path, false otherwise
   */
  hasRegularReportForAllDates = () => {
    const { sampleResultsData } = this.state;

    if (!sampleResultsData || !sampleResultsData.data || !Array.isArray(sampleResultsData.data)) {
      return false;
    }

    const reportPath = sampleResultsData.report_path || {};

    // Check all dates in report_result - return true only if all dates have "regular" in report_path
    return sampleResultsData.data.every(([date]) => {
      // Check if report_path exists for this date
      if (!reportPath[date]) {
        // Date doesn't have report_path entry
        return false;
      }

      // Check specifically for "regular" key with files
      const hasRegular = reportPath[date].regular
        && Array.isArray(reportPath[date].regular)
        && reportPath[date].regular.length > 0;

      return hasRegular;
    });
  };

  /**
   * Check if all report_result dates have report_path entries with files
   * @returns {boolean} true if all dates have report_path, false otherwise
   */
  hasAllDatesWithReportPath = () => {
    const { sampleResultsData } = this.state;

    if (!sampleResultsData || !sampleResultsData.data || !Array.isArray(sampleResultsData.data)) {
      return false;
    }

    const reportPath = sampleResultsData.report_path || {};

    // Check all dates in report_result - return true only if all dates have report_path with files
    return sampleResultsData.data.every(([date]) => {
      // Check if report_path exists for this date
      if (!reportPath[date] || Object.keys(reportPath[date]).length === 0) {
        // Date doesn't have report_path entry
        return false;
      }

      // Check if at least one report type has files
      const hasFiles = Object.values(reportPath[date]).some((reportType) => Array.isArray(reportType) && reportType.length > 0);

      // Return true only if date has report_path entry with files
      return hasFiles;
    });
  };

  renderAddSpecsButton() {
    const { reportData, handleAddSpecsButton, lockResults } = this.props;
    const { isPickingRetests, isPickingPartialGenerate, sampleResultsData } = this.state;
    const canAddSpec = hasPermission(permissions.specManager.addSpec);
    if (
      sampleResultsData.specs_flag?.toString() === "3"
      && reportData.index_id !== ""
      && canAddSpec
      && hasPermission(permissions.product.specManager)
      && !isPickingRetests
      && !isPickingPartialGenerate
    ) {
      return (
        <Button
          type="primary"
          disabled={lockResults}
          onClick={lockResults ? undefined : () => handleAddSpecsButton(reportData.index_id, reportData)}
        >
          Add Specs
        </Button>
      );
    }

    return null;
  }

  /**
   * Render Partial Generate button (Product reports only)
   */
  renderPartialGenerateButton() {
    // Don't show if generate_partial feature is disabled for this company
    if (!hasPermission(permissions.product.generatePartial)) {
      return null;
    }

    const {
      disableInteraction, sampleSubmission, sampleCategory, lockResults,
    } = this.props;
    const {
      isPickingRetests,
      isPickingPartialGenerate,
      testsForPartialGenerate,
      loadingPartialGenerate,
      showDetailedPesticideReport,
      resultsReviewTab,
    } = this.state;

    // Only show for Product reports, not Environment
    if (sampleCategory === "environment") {
      return null;
    }

    // Don't show button if interaction is disabled or in sample submission mode
    if (disableInteraction || sampleSubmission) {
      return null;
    }

    // Don't show if picking retests
    if (isPickingRetests) {
      return null;
    }

    if (resultsReviewTab === "review") {
      return null;
    }

    // If in selection mode, show Cancel and Generate buttons
    if (isPickingPartialGenerate) {
      // Count all selected test-date combinations (same test on multiple dates counts separately)
      const selectedCount = testsForPartialGenerate.length;
      // Check if any selected date has report_path in API response - disable if true
      const hasDatesWithReports = this.hasSelectedDatesWithReports();
      const isGenerateDisabled = selectedCount === 0
        || showDetailedPesticideReport
        || hasDatesWithReports
        || lockResults;

      let tooltipMessage = "";
      if (!lockResults && selectedCount === 0) {
        tooltipMessage = "Please select at least one test";
      } else if (!lockResults && hasDatesWithReports) {
        tooltipMessage = "Reports already generated for selected date(s)";
      }

      return (
        <div className="SampleResultsModal__PickingRetestsContainer">
          {!loadingPartialGenerate && (
            <Button
              type="default"
              onClick={() => this.updatePartialGenerateMode(false)}
            >
              <div>Cancel</div>
            </Button>
          )}
          <StyledTooltip
            title={tooltipMessage}
            placement="right"
          >
            <Button
              type="primary"
              disabled={isGenerateDisabled}
              loading={loadingPartialGenerate}
              onClick={this.handlePartialGenerate}
            >
              <div>
                {loadingPartialGenerate ? "Generating Partial..." : `Generate Partial (${selectedCount})`}
              </div>
            </Button>
          </StyledTooltip>
        </div>
      );
    }

    // Condition 1: If ALL tests are MRL, don't show Generate Partial button
    // (irrespective of whether "regular" exists in report_path)
    if (this.areAllTestsMRL()) {
      return null;
    }

    // Condition 2: If "regular" exists in report_path for ALL dates in report_result,
    // don't show the button. If "regular" is missing for at least one date, show button.
    if (this.hasRegularReportForAllDates()) {
      return null;
    }

    return (
      <Button
        type="primary"
        disabled={lockResults}
        onClick={lockResults ? undefined : () => this.updatePartialGenerateMode(true)}
      >
        Generate Partial
      </Button>
    );
  }

  /**
   * Footer overflow "COA (Edited ID)" menu — Preview, Download, and Regenerate COA.
   * Add Specs and Generate Partial stay as their own footer buttons.
   */
  renderFooterActionsMenu = () => {
    const {
      disableInteraction, sampleSubmission, sampleCategory, lockResults,
    } = this.props;
    const {
      isPickingRetests,
      isPickingPartialGenerate,
      loadingRegenerateCoa,
      loadingCoaDownload,
      sampleResultsData,
    } = this.state;

    if (disableInteraction || isPickingRetests || isPickingPartialGenerate) {
      return null;
    }

    const hasUnitConversionHistoryForCoa = this.sampleHasUnitConversionHistoryForCoa();
    const hasEditHistory = this.sampleHasSampleIdEditHistory()
      || this.sampleHasSampleTypeEditHistory()
      || hasUnitConversionHistoryForCoa;

    // History + account permission: keep the footer even when Edit/Regenerate are off (retest Due)
    if (
      !hasEditHistory
      || sampleSubmission
      || sampleCategory === "environment"
      || !(
        hasPermission(permissions.product.editSampleId)
        || hasPermission(permissions.product.editSampleType)
        || (
          hasUnitConversionHistoryForCoa
          && hasPermission(permissions.product.editResultUnit)
        )
      )
    ) {
      return null;
    }

    const canRegenerateEditedCoa = hasSentFinalResults(sampleResultsData)
      && (
        canEditSampleId()
        || canEditSampleType()
        || (
          hasUnitConversionHistoryForCoa
          && hasPermission(permissions.product.editResultUnit)
        )
      );
    const hasEditedCoaFiles = Boolean(this.getEditedCoaFilePaths());
    const lockCoaActions = lockResults;

    const menuItems = [
      {
        key: "preview-coa",
        disabled: !hasEditedCoaFiles || lockCoaActions,
        label: (
          <div
            className="SampleResultsModal__FooterActionsMenuItem"
            onClick={hasEditedCoaFiles && !lockCoaActions ? this.showCoaPreviewModal : undefined}
          >
            <PlayCircleOutlined className="SampleResultsModal__FooterActionsMenuItemIcon" aria-hidden />
            <span>Preview COA</span>
          </div>
        ),
      },
      {
        key: "download-coa",
        disabled: !hasEditedCoaFiles || loadingCoaDownload || lockCoaActions,
        label: (
          <div
            className="SampleResultsModal__FooterActionsMenuItem"
            onClick={hasEditedCoaFiles && !loadingCoaDownload && !lockCoaActions ? this.handleDownloadCoa : undefined}
          >
            <DownloadOutlined className="SampleResultsModal__FooterActionsMenuItemIcon" aria-hidden />
            <span>{loadingCoaDownload ? "Downloading COA..." : "Download COA"}</span>
          </div>
        ),
      },
    ];

    if (canRegenerateEditedCoa) {
      menuItems.push({
        key: "regenerate-coa",
        disabled: loadingRegenerateCoa || lockCoaActions,
        label: (
          <div
            className="SampleResultsModal__FooterActionsMenuItem"
            onClick={loadingRegenerateCoa || lockCoaActions ? undefined : this.handleRegenerateCoa}
          >
            <ReloadOutlined className="SampleResultsModal__FooterActionsMenuItemIcon" aria-hidden />
            <span>{loadingRegenerateCoa ? "Regenerating COA..." : "Regenerate COA"}</span>
          </div>
        ),
      });
    }

    return (
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
        overlayClassName="SampleResultsModal__FooterActionsMenu"
      >
        <Button
          type="default"
          className="SampleResultsModal__FooterActionsButton"
        >
          COA (Edits)
          <DownOutlined className="SampleResultsModal__FooterActionsButtonIcon" />
        </Button>
      </Dropdown>
    );
  };

  /**
  *Sample Submission view report modal
  */
  renderReportDetails() {
    const {
      reportData,
      sampleCategory,
      sampleSubmission,
      sampleFieldsData,
      linkReportJsonFields,
      fields,
    } = this.props;
    let filteredFieldsObj = [];
    if (!sampleFieldsData && linkReportJsonFields && fields) {
      filteredFieldsObj = Object.keys(reportData).filter((key) => linkReportJsonFields.includes(key)).map((key) => ({
        key: fields.filter((item) => item.json_field === key)[0]?.title_field,
        value: reportData[key],
      }));
    }
    const { activeDate } = this.state;
    if (sampleSubmission) {
      if (sampleCategory === "environment") {
        return (
          <div className="SampleResultsModal__SubHeader">
            <div className="SampleResultsModal__SubHeader__Top">
              <div className="SampleResultsModal__SubHeader__Entry">
                <span className="SampleResultsModal__SubHeader__Label">
                  Location
                </span>
                <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                  <span className="LinkedFieldsSpan SampleResultsModal__Product">
                    {sampleFieldsData
                      .filter((item) => item.value !== "")
                      .map((item, index) => (
                        <React.Fragment key={item.key}>
                          <span className="LinkedFieldTitle">{`${item.key}: `}</span>
                          <span className="LinkedFieldValue">{item.value}</span>
                          {index < sampleFieldsData.filter((i) => i.value !== "").length - 1 && <span className="LinkedFieldsDelimiterDot" />}
                        </React.Fragment>
                      ))}
                    {sampleFieldsData.filter((item) => item.value !== "").length === 0 && <span className="LinkedFieldValue">-</span>}
                  </span>
                </StyledScrollbar>
              </div>
              <span className="SampleResultsModal__SubHeader__Entry">
                <span className="SampleResultsModal__SubHeader__Label--date">
                  Date
                </span>
                {this.getDateString(activeDate, true)}
              </span>
            </div>
            <hr className="SampleResultsModal__SubHeader__Divider" />
            <div className="SampleResultsModal__SubHeader__Bottom SampleResultsModal__SubHeader__Entry">
              <span className="SampleResultsModal__SubHeader__Label">
                Sample ID
              </span>
              <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                <div className="SampleResultsModal__SampleID">
                  <span>{reportData.sample_id}</span>
                </div>
              </StyledScrollbar>
            </div>
          </div>
        );
      }
      if (sampleCategory === "product") {
        return (
          <div className="SampleResultsModal__SubHeader">
            <div className="SampleResultsModal__SubHeader__Top">
              <div className="SampleResultsModal__SubHeader__Entry">
                <span className="SampleResultsModal__SubHeader__Label">
                  Product
                </span>
                <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                  <span className="LinkedFieldsSpan SampleResultsModal__Product">
                    {sampleFieldsData
                      .filter((item) => item.value !== "")
                      .map((item, index) => (
                        <React.Fragment key={item.key}>
                          <span className="LinkedFieldTitle">{`${item.key}: `}</span>
                          <span className="LinkedFieldValue">{item.value}</span>
                          {index < sampleFieldsData.filter((i) => i.value !== "").length - 1 && <span className="LinkedFieldsDelimiterDot" />}
                        </React.Fragment>
                      ))}
                    {sampleFieldsData.filter((item) => item.value !== "").length === 0 && <span className="LinkedFieldValue">-</span>}
                  </span>
                </StyledScrollbar>
              </div>
              <span className="SampleResultsModal__SubHeader__Entry">
                <span className="SampleResultsModal__SubHeader__Label--date">
                  Date
                </span>
                {this.getDateString(activeDate, true)}
              </span>
            </div>
            <div className="SampleResultsModal__SubHeader__Bottom SampleResultsModal__SubHeader__Entry SampleResultsModal__SubHeader__SampleIdRow">
              <span className="SampleResultsModal__SubHeader__Label">
                Sample ID
              </span>
              <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                <div className="SampleResultsModal__SampleID">
                  {this.renderDisplayedSampleId()}
                </div>
              </StyledScrollbar>
              {this.renderSampleIdActionsMenu()}
            </div>
            {this.renderSampleTypeRow()}
            <hr className="SampleResultsModal__SubHeader__Divider" />
            {/* {(hasPesticideTest && showDetailedPesticideReport && pesticideCommodity) && (
              <div className="SampleResultsModal__SubHeader__Entry SampleResultsModal__SubHeader__Bottom">
                <span className="SampleResultsModal__SubHeader__Label">
                  Sample Type
                </span>
                <span>{pesticideCommodity}</span>
              </div>
            )} */}
          </div>
        );
      }
    } else if (sampleCategory === "environment") {
      return (
        <div className="SampleResultsModal__SubHeader">
          <div className="SampleResultsModal__SubHeader__Top">
            <div className="SampleResultsModal__SubHeader__Entry">
              <span className="SampleResultsModal__SubHeader__Label">
                Location
              </span>
              <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                <span className="LinkedFieldsSpan SampleResultsModal__Product">
                  {filteredFieldsObj
                    .filter((item) => item.value !== "")
                    .map((item, index) => (
                      <React.Fragment key={item.key}>
                        <span className="LinkedFieldTitle">{`${item.key}: `}</span>
                        <span className="LinkedFieldValue">{item.value}</span>
                        {index < filteredFieldsObj.filter((i) => i.value !== "").length - 1 && <span className="LinkedFieldsDelimiterDot" />}
                      </React.Fragment>
                    ))}
                  {filteredFieldsObj.filter((item) => item.value !== "").length === 0 && <span className="LinkedFieldValue">-</span>}
                </span>
              </StyledScrollbar>
            </div>
            <span className="SampleResultsModal__SubHeader__Entry">
              <span className="SampleResultsModal__SubHeader__Label--date">
                Date
              </span>
              {this.getDateString(activeDate, true)}
            </span>
          </div>
          <hr className="SampleResultsModal__SubHeader__Divider" />
          <div className="SampleResultsModal__SubHeader__Bottom SampleResultsModal__SubHeader__Entry">
            <span className="SampleResultsModal__SubHeader__Label">
              Sample ID
            </span>
            <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
              <div className="SampleResultsModal__SampleID">
                <span>{reportData.sample_id}</span>
              </div>
            </StyledScrollbar>
          </div>
        </div>
      );
    } else {
      return (
        <div className="SampleResultsModal__SubHeader">
          <div className="SampleResultsModal__SubHeader__Top">
            <div className="SampleResultsModal__SubHeader__Entry">
              <span className="SampleResultsModal__SubHeader__Label">
                Product
              </span>
              <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
                <span className="LinkedFieldsSpan SampleResultsModal__Product">
                  {filteredFieldsObj
                    .filter((item) => item.value !== "")
                    .map((item, index) => (
                      <React.Fragment key={item.key}>
                        <span className="LinkedFieldTitle">{`${item.key}: `}</span>
                        <span className="LinkedFieldValue">{item.value}</span>
                        {index < filteredFieldsObj.filter((i) => i.value !== "").length - 1 && <span className="LinkedFieldsDelimiterDot" />}
                      </React.Fragment>
                    ))}
                  {filteredFieldsObj.filter((item) => item.value !== "").length === 0 && <span className="LinkedFieldValue">-</span>}
                </span>
              </StyledScrollbar>
            </div>
            <span className="SampleResultsModal__SubHeader__Entry">
              <span className="SampleResultsModal__SubHeader__Label--date">
                Date
              </span>
              {this.getDateString(activeDate, true)}
            </span>
          </div>
          <div className="SampleResultsModal__SubHeader__Bottom SampleResultsModal__SubHeader__Entry SampleResultsModal__SubHeader__SampleIdRow">
            <span className="SampleResultsModal__SubHeader__Label">
              Sample ID
            </span>
            <StyledScrollbar className="SampleResultsModal__SampleIDScrollBar">
              <div className="SampleResultsModal__SampleID">
                {this.renderDisplayedSampleId()}
              </div>
            </StyledScrollbar>
            {this.renderSampleIdActionsMenu()}
          </div>
          {this.renderSampleTypeRow()}
          <hr className="SampleResultsModal__SubHeader__Divider" />
          {/* {(hasPesticideTest && showDetailedPesticideReport && pesticideCommodity) && (
            <div className="SampleResultsModal__SubHeader__Entry SampleResultsModal__SubHeader__Bottom">
              <span className="SampleResultsModal__SubHeader__Label">
                Sample Type
              </span>
              <span>{pesticideCommodity}</span>
            </div>
          )} */}
        </div>
      );
    }
    return null;
  }

  render() {
    const {
      sampleResultsData,
      showRetestModal,
      keyOfTestResultTable,
      currentSlide,
      totalSlides,
      activeDate,
      isPickingRetests,
      testToRetest,
      isPickingPartialGenerate,
      disabledTests,
      disabledTestsForPartialGenerate,
      loadingData,
      awaitingRetestRequest,
      showDetailedPesticideReport,
      pesticideDetailTest,
      sampleIdEditHistoryForEdit,
      showEditSampleIdModal,
      showSampleIdChangeHistoryModal,
      showSampleTypeChangeHistoryModal,
      showCoaPreview,
      showConvertUnitModal,
      convertUnitRow,
      isSavingUnitConversion,
      isResettingUnitsToDefault,
      showRetestMethodModal,
      showNewSampleDatePicker,
      showNewSampleConfirmation,
      newSampleDate,
      awaitingNewSampleRequest,
      showNewSampleRetestSuccess,
      newSampleRetestSuccessDate,
      showNewSampleRetestReceipt,
      newSampleRetestReceiptSubmission,
      showSendNewSampleWizard,
      reviewSendNewSampleLoading,
      reviewNewSampleSuccessHeading,
      resultsReviewTab,
      showReleaseConfirm,
      testToRelease,
      releasingTest,
      showReleaseSuccess,
      showUpdateSpecsPrompt,
      releasedTestItem,
      releasedTestDate,
      tabCountBurst,
      holdResultsReviewTabs,
      reviewSelectedTests,
      showContactCsmModal,
      showContactCsmSuccess,
      submittingContactCsm,
      // isRetest,
    } = this.state;
    const {
      disableInteraction,
      lockResults = false,
      reportData,
      sampleSubmission = false,
      sampleCategory,
    } = this.props;

    const specFlagInfo = sampleResultsData?.specs_flag && VALID_SPECS_SET.has(sampleResultsData.specs_flag) ? SPEC_FLAGS_MAP[sampleResultsData.specs_flag] : SPEC_FLAGS_MAP.invalid;
    const isInProcessSpec = sampleResultsData?.specs_flag === "0" || sampleResultsData?.specs_flag === "4";
    const lockFinalResult = lockResults && !isInProcessSpec;

    const oldestDate = this.getOldestReportDate(sampleResultsData);
    const editedCoaFilePaths = showCoaPreview ? this.getEditedCoaFilePaths() : null;
    const currentDateEntry = sampleResultsData?.data?.[currentSlide] || sampleResultsData?.data?.[0];
    const currentReviewCount = currentDateEntry
      ? this.getOosPartitionForDate(currentDateEntry[0], currentDateEntry[1]).reviewTests.length
      : 0;
    const showReviewFooter = this.shouldShowOosReviewTabs()
      && currentReviewCount > 0
      && resultsReviewTab === "review";

    return (
      <Modal
        open
        closable={false}
        centered
        footer={null}
        onCancel={this.handleCloseModal}
        wrapClassName="SampleResultsModal"
        className="SampleResultsModal ProdSpecManagerModal"
        width="849px"
      >
        <div className="SampleResultsModal__Header">
          {[this.getDateString(activeDate, false), "Report"].join(" ")}
          <CloseOutlined
            className="SampleResultsModal__CloseIcon"
            aria-label="Close"
            onClick={this.handleCloseModal}
          />
        </div>
        <div className="SampleResultsModal__Body">
          {!loadingData && this.renderReportDetails()}
          {!loadingData && sampleResultsData && this.renderNewSampleRetestBanner()}
          {(loadingData && !sampleSubmission) && <div className={`SampleResultsModal__Loading${["4", "5", "6"].includes(reportData.specs_flag) ? "--retest" : ""}`}><LoadingDots width={28} height={28} fill="var(--color-content-darkblue-primary)" /></div>}
          {(loadingData && sampleSubmission) && <div className={`SampleResultsModal__Loading${["4", "5", "6"].includes(reportData.specs_flag) ? "--retest" : ""}`}><LoadingDots width={28} height={28} fill="var(--color-content-darkblue-primary)" /></div>}
          {!loadingData && !sampleResultsData && (
            <NoResults image={emptyStateIcon} message="No Result Found" className="ReportsTable__NoResults" />
          )}
          {!loadingData && sampleResultsData && (
            <>
              <Carousel
                showIndicators={false}
                showThumbs={false}
                showArrows={false}
                showStatus={false}
                selectedItem={currentSlide}
                swipeable={Object.keys(sampleResultsData.data).length > 1}
                onChange={this.handleCarouselChange}
              >
                {Object.keys(sampleResultsData.data).length > 0
                  && sampleResultsData.data.map((data, idx) => {
                    const { reviewTests, resultsTests } = this.getOosPartitionForDate(data[0], data[1]);
                    const showOosReviewTabs = this.shouldShowOosReviewTabs()
                      || Boolean(tabCountBurst?.results)
                      || Boolean(holdResultsReviewTabs);
                    const hasReviewTests = reviewTests.length > 0;
                    const isReviewTab = showOosReviewTabs && hasReviewTests && resultsReviewTab === "review";
                    const tableData = isReviewTab ? reviewTests : resultsTests;
                    return (
                      <SampleTestResultTable
                        ref={(el) => {
                          if (this.testResultTableRefs.current === null) {
                            this.testResultTableRefs.current = [];
                          }
                          this.testResultTableRefs.current[idx] = el;
                        }}
                        key={`${idx}${keyOfTestResultTable}`}
                        tableData={showOosReviewTabs || isPickingPartialGenerate ? tableData : data[1]}
                        specs_flag={specFlagInfo.label}
                        isPickingRetests={isPickingRetests || isPickingPartialGenerate}
                        checkBoxOnChange={isPickingPartialGenerate ? this.addTestToPartialGenerate : this.addTestToRetest}
                        disabledTests={isPickingPartialGenerate ? disabledTestsForPartialGenerate : disabledTests}
                        isPartialGenerateMode={isPickingPartialGenerate}
                        reportData={reportData}
                        showDetailedPesticideReport={showDetailedPesticideReport}
                        pesticideDetailTest={pesticideDetailTest}
                        pesticideDetailsToggle={this.handlePesticideDetailsToggle}
                        activeDate={activeDate}
                        testDate={data[0]}
                        reportDataRefresh={this.reportDataRefresh}
                        reportPath={sampleResultsData?.report_path}
                        oldestDate={oldestDate}
                        showUnitConversion={this.isUnitColumnVisible()}
                        canConvertUnits={this.canConvertUnits()}
                        canSetUnitsToDefault={this.canSetUnitsToDefault()}
                        isResettingUnitsToDefault={isResettingUnitsToDefault}
                        onConvertUnit={this.openConvertUnitModal}
                        onConfirmSetUnitsToDefault={this.confirmSetUnitsToDefault}
                        showResultsReviewTabs={showOosReviewTabs}
                        resultsReviewTab={resultsReviewTab}
                        resultsCount={resultsTests.length}
                        reviewCount={reviewTests.length}
                        onResultsReviewTabChange={this.handleResultsReviewTabChange}
                        isReviewTab={isReviewTab}
                        onReleaseResult={this.openReleaseConfirm}
                        onReviewSelectionChange={this.handleReviewSelectionChange}
                        tabCountBurst={tabCountBurst}
                        holdResultsReviewTabs={holdResultsReviewTabs}
                        updateSpecsPromptOpen={
                          showUpdateSpecsPrompt
                          && resultsReviewTab === "results"
                          && Boolean(releasedTestDate)
                          && releasedTestDate === data[0]
                        }
                        updateSpecsPromptTest={releasedTestItem?.test}
                        onUpdateSpecs={this.handleUpdateSpecsNavigate}
                        onUpdateSpecsNotNow={this.handleUpdateSpecsNotNow}
                        onUpdateSpecsDontShowAgain={this.handleUpdateSpecsDontShowAgain}
                        onUpdateSpecsOpenChange={this.handleUpdateSpecsPromptOpenChange}
                        lockResults={lockResults}
                      />
                    );
                  })}
              </Carousel>

              {Object.keys(sampleResultsData.data).length > 1 && (
                <div className="SampleResultsModal__CarouselControls">
                  <DatePicker
                    data={sampleResultsData.data}
                    activeDate={activeDate}
                    currentSlide={currentSlide}
                    totalSlides={totalSlides}
                    updateActiveDate={this.handleDateChanged}
                    disabled={showDetailedPesticideReport}
                  />
                </div>
              )}

              <div className="SampleResultsModal__Footer">
                <div>
                  {showRetestModal && (
                    <NewSampleRetestConfirmationModal
                      testToRetest={testToRetest}
                      currNumOfRetests={totalSlides - 1}
                      maxNumOfRetests={MAX_RETESTS_ALLOWED}
                      onCancel={this.hideRequestRetestModal}
                      onConfirm={this.handleRetestRequest}
                      awaitingRetestRequest={awaitingRetestRequest}
                    />
                  )}

                  {showRetestMethodModal && (
                    <RetestMethodModal
                      onCancel={this.handleCancelRetestMethod}
                      onContinue={this.handleRetestMethodContinue}
                    />
                  )}

                  {showNewSampleDatePicker && (
                    <NewSampleDatePickerModal
                      onCancel={this.handleCancelNewSampleDate}
                      onContinue={this.handleNewSampleDateContinue}
                    />
                  )}

                  {showNewSampleConfirmation && (
                    <NewSampleRetestConfirmationModal
                      testToRetest={testToRetest}
                      currNumOfRetests={totalSlides - 1}
                      maxNumOfRetests={MAX_RETESTS_ALLOWED}
                      newSampleDate={newSampleDate}
                      onCancel={this.handleCancelNewSampleConfirmation}
                      onConfirm={this.handleNewSampleRetestRequest}
                      awaitingRetestRequest={awaitingNewSampleRequest}
                    />
                  )}

                  <div className="SampleResultsModal__Footer__SpecsFlagAndButtons">
                    <div className="SampleResultsModal__Footer__FinalResult">
                      <span className="SampleResultsModal__Footer__Label">
                        Final Result
                      </span>
                      <span
                        className="SampleResultsModal__Footer__SpecsFlag"
                        style={lockFinalResult
                          ? undefined
                          : { color: specFlagInfo.color }}
                      >
                        {lockFinalResult ? (
                          <LockedValue
                            locked
                            showLabel
                            label="Status locked until payment is completed"
                          />
                        ) : (
                          <>
                            <img
                              src={specFlagInfo.icon}
                              alt=""
                            />
                            <span>{formatSpecAlertLabel(sampleResultsData?.specs_flag, specFlagInfo.label, reportData)}</span>
                          </>
                        )}
                      </span>
                    </div>
                    {!disableInteraction && (
                      <div className="SampleResultsModal__Footer__Buttons">
                        {this.renderFooterActionsMenu()}
                        {!sampleSubmission && this.renderAddSpecsButton()}
                        {!sampleSubmission && this.handleRenderingRequestRetestButton()}
                        {this.renderPartialGenerateButton()}
                        {showReviewFooter && (
                          <>
                            <Tooltip
                              title={reviewSelectedTests.length ? "" : "Select at least one test that requires a decision"}
                              placement="top"
                              classNames={{ root: "SampleTestResultTable__InvestigationTooltip" }}
                              getPopupContainer={() => document.body}
                            >
                              <span>
                                <Button
                                  type="default"
                                  className="SampleResultsModal__ContactCsmBtn"
                                  disabled={!reviewSelectedTests.length}
                                  icon={<UserOutlined />}
                                  onClick={this.openContactCsmModal}
                                >
                                  Contact CSM
                                </Button>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={reviewSelectedTests.length ? "" : "Select at least one test that requires a decision"}
                              placement="top"
                              classNames={{ root: "SampleTestResultTable__InvestigationTooltip" }}
                              getPopupContainer={() => document.body}
                            >
                              <span>
                                <Button
                                  type="default"
                                  className="SampleResultsModal__SendNewSampleBtn"
                                  disabled={!reviewSelectedTests.length || reviewSendNewSampleLoading}
                                  onClick={this.openReviewSendNewSample}
                                >
                                  Send new sample
                                </Button>
                              </span>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {showSendNewSampleWizard && (
          <SendNewSampleWizardModal
            testNames={testToRetest}
            sampleSize={this.getSampleSizeForTests(testToRetest)}
            loading={reviewSendNewSampleLoading}
            onCancel={this.closeSendNewSampleWizard}
            onSubmit={this.submitReviewSendNewSample}
          />
        )}
        {showContactCsmModal && (
          <ContactCsmModal
            productName={this.getContactCsmProductName()}
            date={this.getDateString(activeDate, true)}
            sampleId={this.getDisplayedSampleId()}
            testNames={reviewSelectedTests}
            loading={submittingContactCsm}
            onBack={this.closeContactCsmModal}
            onCancel={this.closeContactCsmModal}
            onSubmit={this.submitContactCsmRequest}
          />
        )}
        {showContactCsmSuccess && (
          <ContactCsmSuccessModal onDone={this.closeContactCsmSuccess} />
        )}
        {showReleaseConfirm && (
          <ReleaseTestResultsModal
            testItem={testToRelease}
            loading={releasingTest}
            onCancel={this.closeReleaseConfirm}
            onConfirm={this.confirmReleaseTest}
          />
        )}
        {showReleaseSuccess && (
          <ReleaseTestSuccessModal
            testName={releasedTestItem?.test}
            onDone={this.closeReleaseSuccess}
          />
        )}
        {showEditSampleIdModal && (
          <EditSampleIdModal
            reportData={reportData}
            sampleIdEditHistory={sampleIdEditHistoryForEdit}
            displayedSampleId={this.getDisplayedSampleId()}
            onClose={this.hideEditSampleIdModal}
            onSaveSuccess={this.handleSampleIdEditSaveSuccess}
          />
        )}
        {showSampleIdChangeHistoryModal && (
          <SampleIdChangeHistoryModal
            reportData={reportData}
            onClose={this.hideSampleIdChangeHistoryModal}
          />
        )}
        {showSampleTypeChangeHistoryModal && (
          <SampleIdChangeHistoryModal
            reportData={reportData}
            onClose={this.hideSampleTypeChangeHistoryModal}
            columns={SAMPLE_TYPE_HISTORY_COLUMNS}
            fetchHistory={getSampleTypeEditHistory}
            receivedDateFormat="YYYY/MM/DD"
          />
        )}
        {showCoaPreview && editedCoaFilePaths && (
          <ReportPreviewModal
            filePaths={editedCoaFilePaths}
            handleCloseForPreview={this.hideCoaPreviewModal}
          />
        )}
        {showConvertUnitModal && convertUnitRow && (
          <ConvertUnitModal
            testName={convertUnitRow.test}
            testCategory={convertUnitRow.testCategory}
            hasTestDetail={convertUnitRow.hasTestDetail}
            testDetailType={convertUnitRow.testDetailType}
            currentResult={convertUnitRow.result}
            currentSpec={convertUnitRow.specs}
            currentUnit={convertUnitRow.unit}
            specUnit={convertUnitRow.specUnit}
            testDate={convertUnitRow.testDate}
            isSaving={isSavingUnitConversion}
            onClose={this.hideConvertUnitModal}
            onUpdateResult={this.handleConvertUnitUpdate}
          />
        )}
        {showNewSampleRetestSuccess && newSampleRetestSuccessDate && (
          <NewSampleRetestSuccessModal
            submissionDate={newSampleRetestSuccessDate}
            heading={reviewNewSampleSuccessHeading}
            onDone={this.handleNewSampleRetestSuccessDone}
          />
        )}
        {showNewSampleRetestReceipt && newSampleRetestReceiptSubmission && (
          <NewSampleRetestReceiptModal
            showReceipt={showNewSampleRetestReceipt}
            onClose={this.handleNewSampleRetestReceiptClose}
            submission={newSampleRetestReceiptSubmission}
            sampleCategory={sampleCategory || "product"}
          />
        )}
      </Modal>
    );
  }
}

SampleResultsModal.contextType = AppContext;
export default SampleResultsModal;
